<div class="animated fadeInDown DocumentContainer" *ngIf="showInvoiceVisualizer">

   <div class="InvoiceVisualizerTitle">
    <button class="ModernButton ModernButtonSecondary InvoiceModelChangeButton" (click)="OpenInvoiceModelSettings();">
      <i class="material-icons" *ngIf="this.CurrentInvoice.ModelSettings.ShowInvoiceSettings != true;">keyboard_arrow_left</i>
      <i class="material-icons" *ngIf="this.CurrentInvoice.ModelSettings.ShowInvoiceSettings == true;">keyboard_arrow_right</i>
      <i class="material-icons" style="font-size: 18px;">settings</i>
    </button>
    <button [disabled]="this.DocumentBodyLoading || this.parent.loading" class="ModernButton ModernButtonSecondary EfacturaButton" (click)="GetEFacturaXML(this.CurrentInvoice);">
      <i class="material-icons">download</i>
      <span>{{'DownloadEFactura' | translate}}</span>
    </button>

    <button [disabled]="this.DocumentBodyLoading || this.parent.loading" class="ModernButton ModernButtonAccent EfacturaButton" (click)="this.ShowEFacturaQuestion = true;" *ngIf="this.CurrentInvoice.Details?.EFacturaDetails?.Status?.ID == -1 || this.CurrentInvoice.Details?.EFacturaDetails?.Status?.ID == 0;">
      <i class="material-icons">play_arrow</i>
      <span>{{'APIEFactura' | translate}}</span>
    </button>

    <button [disabled]="this.DocumentBodyLoading || this.parent.loading" class="ModernButton ModernButtonPrimary EfacturaButton" (click)="GetEFacturaState(this.CurrentInvoice);" *ngIf="this.CurrentInvoice.Details?.EFacturaDetails?.Status?.ID == 1;">
      <i class="material-icons">sync</i>
      <span>{{'UpdateEFacturaStatus' | translate}}</span>
    </button>

    <button [disabled]="this.DocumentBodyLoading || this.parent.loading" class="ModernButton ModernButtonSecondary EfacturaButton" (click)="GetEFacturaFiles(this.CurrentInvoice);" *ngIf="this.CurrentInvoice.Details?.EFacturaDetails?.Status?.ID == 2;">
      <i class="material-icons">downloading</i>
      <span>{{'DownloadEFacturaPDF' | translate}}</span>
    </button>
   </div>

   <div class="PopUpCommands" style="margin-left: 2.5%;box-shadow: 0 4px 3px -2px rgb(0 0 0 / 30%);width: 95%;">
    <button class="ModernButton ModernButtonPrimary VizualizeCommandButton" style="outline: none;" (click)="ExportInvoice(this.CurrentInvoice);">
      <i class="material-icons">file_copy</i>
      <span>{{ 'Receptions.Document.Export' | translate }}</span>
    </button>

    <button class="ModernButton ModernButtonSecondary VizualizeCommandButton" style="outline: none;" (click)="PrintInvoice(this.CurrentInvoice);">
      <i class="material-icons">print</i>
      <span>{{ 'Receptions.Document.Print' | translate }}</span>
    </button>

    <button class="ModernButton ModernButtonSecondary VizualizeCommandButton" style="outline: none;" (click)="this.parent.InitializeEmailSendContainer(this.CurrentInvoice.Client, this.CurrentInvoice.GeneralDocType, this.CurrentInvoice.ID);">
      <i class="material-icons">attach_email</i>
      <span>{{ 'Email' | translate }}</span>
    </button>

    <button class="ModernButton ModernButtonSecondary VizualizeCommandButton" style="outline: none;" *ngIf="this.CurrentInvoice.Details?.ShippingDetails?.TrackingLabel?.length > 0;" (click)="TrackInvoice(CurrentInvoice);">
      <i class="material-icons">near_me</i>
      <span>{{ 'Track' | translate }}</span>
    </button>

    <button class="ModernButton ModernButtonSuccess BackCommandButton" style="outline: none;float: right;" (click)="this.parent.RedirectToURL('dashboard/documents/invoices');">
      <i class="material-icons">keyboard_double_arrow_left</i>
      <span>{{ 'BackToInvoicesMenu' | translate }}</span>
    </button>

    <button [disabled]="this.DocumentBodyLoading || this.parent.loading" (click)="AutoPrintDocument(this.CurrentInvoice);" class="ModernButton ModernButtonSecondary VizualizeCommandButton" matTooltip="{{ 'AutoPrintDesc' | translate }}" matTooltipClass='neutral-tool-tip' style="outline: none;float: right;">
      <i class="material-icons">print</i>
      <span>{{ 'AutoPrint' | translate }}</span>
    </button>

    <mat-progress-bar mode="query" class="DocumentProgressBar" *ngIf="DocumentBodyLoading"></mat-progress-bar>
  </div>

   <div class="PopUpBody" style="max-height: 75vh;">
      <p class="DocumentBodyCanceled" *ngIf="CurrentInvoice.DocumentStatus.ID == -1;">anulata</p>

      <table style="border: solid 1px #aaa;
      padding: 20px;
      font-weight: 400;
      margin-top: 2.5%;
      position: relative;
      margin-bottom: 2.5px;
      border-collapse: separate !important;
      border-radius: 4px;">
        <tbody>
          <tr>
            <td style="border-radius: 3px;">
              <table style="width: 100%;">
                <tbody>
                  <tr style="width: 50%;max-height: 100px;float: left;">
                    <img alt="{{this.CurrentInvoice.Company.Name}}" *ngIf="this.CurrentInvoice.AccountingNumber.AccountingSeries.LogoPath != null;" [src]="this.parent.BackendServiceUrl + this.CurrentInvoice.AccountingNumber.AccountingSeries.LogoPath" style="max-width: 50%;max-height: 100%;"/>
                    <td style="width: 75%;
                    float: left;
                    font-size: 26px;
                    font-weight: 700;
                    line-height: 30px;
                    text-transform: uppercase;" *ngIf="this.CurrentInvoice.AccountingNumber.AccountingSeries.LogoPath == null;">{{this.CurrentInvoice.Company.Name}}</td>
                  </tr>
                  <tr style="width: 50%;float: left;">
                     <table style="width: 100%;float: left;">
                       <tbody>
                        <tr style="width: 50%;float: left;font-size: 18px;font-weight: 700;text-transform: uppercase;">
                          {{CurrentInvoice.DocType.Meaning}}
                        </tr>
                        <tr style="width: 50%;float: left;text-align: right;font-weight: 700;font-size: 22px;padding-right: 5px;">
                          {{CurrentInvoice.AccountingNumber.DisplayValue}}
                        </tr>
                       </tbody>
                     </table>
        
                      <table style="width: 100%;float: left;margin-top: 10px;">
                        <tbody>
                          <tr style="width: 50%;float: left;font-size: 13px;">
                            {{ 'CreatingDate' | translate }}: {{CurrentInvoice.EventRegisterUIDate}}
                          </tr>
                          <tr style="width: 50%;float: left;text-align: right;font-size: 13px;padding-right: 5px;" *ngIf="CurrentInvoice.VATs.length == 1;">
                            {{ 'VATRate' | translate }}: <span *ngFor="let v of CurrentInvoice.VATs">{{v.Percentage}}%</span>
                          </tr>
                        </tbody>
                      </table>
        
                     <table style="width: 100%;float: left;margin-top: 10px;">
                       <tbody>
                        <tr style="width: 100%;float: left;height: 40px;background: #254a91;border-radius: 3px;line-height: 40px;text-align: right;color: #fff;font-size: 20px;font-weight: 500;">
                          <td style="float: left;width: 100%;padding: 0;">
                           <table style="width: 100%;">
                             <tbody>
                              <tr style="width: 50%;float: left;font-size: 18px;text-align: left;padding-left: 10px;text-transform: uppercase;">
                                {{ 'TotalValue' | translate }}
                              </tr>
                              <tr style="width: 50%;float: left;font-size: 18px;text-align: right;padding-right: 10px;text-transform: uppercase;">
                                <span>{{CurrentInvoice.Total.UITotalQtyPriceVAT.Integer}}</span>
                                <span>{{CurrentInvoice.Total.UITotalQtyPriceVAT.Decimals}}</span> 
                                <span style="font-size: 14px;"> {{CurrentInvoice.Currency.Name}}</span>
                              </tr>
                             </tbody>
                           </table>
                          </td>
                        </tr>
                       </tbody>
                     </table>
        
                  </tr>
                </tbody>
              </table>
        
              <table style="width: 100%;">
                <tbody>
                  <tr style="width: 50%;max-height: 200px;float: left;min-height: 50px;">
                    <td style="float: left;width: 100%;height: auto;min-height: 50px;padding: 0;">
                      <tr style="width: 60%;
                      float: left;
                      padding-left: 5px;
                      text-transform: uppercase;
                      font-weight: 500;
                      height: 30px;
                      line-height: 30px;
                      border-bottom: solid 2px #254a91;
                      margin-top: 10px;">{{ 'Supplier' | translate }}</tr>
        
                      <tr style="width: 100%;
                      float: left;
                      padding-left: 5px;
                      margin-top: 10px;
                      text-transform: uppercase;
                      font-weight: 700;
                      font-size: 16px;">{{this.CurrentInvoice.Company.Name}}</tr>
        
                      <tr style="width: 100%;
                      float: left;
                      padding-left: 5px;
                      margin-top: 10px;
                      text-transform: uppercase;
                      font-size: 12px;">{{ 'VAT' | translate }}: {{this.CurrentInvoice.Company.VATNumber}}</tr>
        
                       <tr style="width: 100%;
                       float: left;
                       padding-left: 5px;
                       margin-top: 0px;
                       text-transform: uppercase;
                       font-size: 12px;">{{ 'RegCom' | translate }}: {{this.CurrentInvoice.Company.COCRegisterNr}}</tr>
        
                       <tr style="width: 100%;
                       float: left;
                       padding-left: 5px;
                       margin-top: 0px;
                       text-transform: uppercase;
                       font-size: 12px;">{{ 'Partners.PartnerWindow.Address' | translate }} {{this.CurrentInvoice.Company.Addresses[0].Country.Name}} 
                       {{this.CurrentInvoice.Company.Addresses[0].StateProvince}}
                       {{this.CurrentInvoice.Company.Addresses[0].City}}
                       {{this.CurrentInvoice.Company.Addresses[0].AddressLine}}</tr>
        
                       <tr style="width: 100%;
                       float: left;
                       padding-left: 5px;
                       margin-top: 0px;
                       text-transform: uppercase;
                       font-size: 12px;">{{ 'Partners.PartnerWindow.BankAccountNumber' | translate }} ({{this.CurrentInvoice.Company.Banks[0]?.BankAccounts[0]?.Currency.Name}}) : {{this.CurrentInvoice.Company.Banks[0]?.BankAccounts[0]?.AccountNumber}}</tr>
        
                       <tr style="width: 100%;
                       float: left;
                       padding-left: 5px;
                       margin-top: 0px;
                       text-transform: uppercase;
                       font-size: 12px;">{{ 'Partners.PartnerWindow.Bank' | translate }}: {{this.CurrentInvoice.Company.Banks[0]?.Name}}</tr>
        
                    </td>
                  </tr>
                  <tr style="width: 50%;max-height: 200px;float: left;min-height: 50px;">
                    <td style="float: left;width: 100%;height: auto;min-height: 50px;padding: 0;">
                      <tr style="width: 60%;
                      float: left;
                      padding-left: 5px;
                      text-transform: uppercase;
                      font-weight: 500;
                      height: 30px;
                      line-height: 30px;
                      border-bottom: solid 2px #254a91;
                      margin-top: 10px;">{{ 'Client' | translate }}</tr> 
        
                      <tr style="width: 100%;
                      float: left;
                      padding-left: 5px;
                      margin-top: 10px;
                      text-transform: uppercase;
                      font-weight: 700;
                      font-size: 16px;">{{this.CurrentInvoice.Client.Name}}</tr>
        
                      <tr style="width: 100%;
                      float: left;
                      padding-left: 5px;
                      margin-top: 10px;
                      text-transform: uppercase;
                      font-size: 12px;">{{ 'VAT' | translate }}: {{this.CurrentInvoice.Client.VAT}}</tr>
        
                      <tr style="width: 100%;
                      float: left;
                      padding-left: 5px;
                      margin-top: 0px;
                      text-transform: uppercase;
                      font-size: 12px;">{{ 'Partners.PartnerWindow.Address' | translate }} {{this.CurrentInvoice.Client.BillingAddress.StateProvince}} {{this.CurrentInvoice.Client.BillingAddress.City}} {{this.CurrentInvoice.Client.BillingAddress.AddressLine}}</tr>
        
                      <tr style="width: 100%;
                      float: left;
                      padding-left: 5px;
                      margin-top: 0px;
                      text-transform: uppercase;
                      font-size: 12px;">{{ 'Country' | translate }}: {{this.CurrentInvoice.Client.BillingAddress.Country.Name}}</tr>
        
                      <tr style="width: 100%;
                      float: left;
                      padding-left: 5px;
                      margin-top: 0px;
                      text-transform: uppercase;
                      font-size: 12px;">{{ 'Login.Email' | translate }}: {{this.CurrentInvoice.Client.ContactInfo.Email}}</tr>
                    </td>
                  </tr>
                </tbody>
              </table>
        
              <table style="width: 100%;">
                <tbody>
                  <tr style="float: left;width: 100%;margin-top: 20px;height: 2px;background: #254a91;">
                    
                  </tr>
                  <tr style="float: left;width: 100%;height: 50px;">
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 7.5%;text-align: center;">
                      {{ 'Receptions.Table.Nr' | translate }}
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 30%;text-align: left;">
                      {{ 'Receptions.Table.Name' | translate }}
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 10%;text-align: center;">
                      {{ 'Receptions.Table.MU' | translate }}
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 10%;text-align: center;">
                      {{ 'Receptions.Table.Qty' | translate }}
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 17.5%;text-align: right;">
                      {{ 'Receptions.Table.Price' | translate }} ({{this.CurrentInvoice.Currency.Name}})
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 15%;text-align: right;">
                      {{ 'Receptions.Table.Total' | translate }} ({{this.CurrentInvoice.Currency.Name}})
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 10%;text-align: center;">
                      {{ 'Receptions.Table.VAT' | translate }}
                    </td>
                  </tr>
                  <tr style="float: left;width: 100%;margin-top: 0px;height: 2px;background: #254a91;">
                    
                  </tr>
        
                  <tr style="float: left;width: 100%;height: auto;min-height: 12px;padding-bottom: 10px;" *ngFor="let p of CurrentInvoice.Products; let i=index;" [ngClass]="{'GrayRow': i % 2 != 0}">
                    <td style="line-height: 12px;font-size: 12px;padding-top: 10px;font-weight: 500;height: auto;float: left;min-height: 12px;width: 7.5%;text-align: center;">
                      {{i + 1}}
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 10px;height: auto;float: left;min-height: 12px;width: 30%;text-align: left;">
                      <p style="margin:0;margin-bottom:5px;">{{p.ProductInvoiceInfo.Name}}</p>
                      <p *ngFor="let row of p.ProductInvoiceInfo.DescriptionRows; let j=index;" style="height: auto;margin:0;min-height: 16px;line-height: 16px;color: #aaa;">
                          {{row}}
                      </p>
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 10px;font-weight: 500;height: auto;float: left;min-height: 12px;width: 10%;text-align: center;">
                      {{p.ProductInvoiceInfo.MeasuringUnit.Name}}
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 10px;font-weight: 500;height: auto;float: left;min-height: 12px;width: 10%;text-align: center;">
                      {{p.ProductInvoiceInfo.Quantity}}
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 10px;font-weight: 500;height: auto;float: left;min-height: 12px;width: 17.5%;text-align: right;">
                      <span *ngIf="p.ProductInvoiceInfo.Price.Discount == null || p.ProductInvoiceInfo.Price.Discount.Value == null">{{p.ProductInvoiceInfo.Price.UIUnitPrice}}</span>
                      <span *ngIf="p.ProductInvoiceInfo.Price.Discount != null && p.ProductInvoiceInfo.Price.Discount.Value != null">{{p.ProductInvoiceInfo.Price.UIUnitPriceDiscount}}</span>
        
                      <p style="height: auto;margin:0;min-height: 16px;line-height: 16px;color: #aaa;font-weight: 400;" *ngIf="p.ProductInvoiceInfo.Price.Discount != null && p.ProductInvoiceInfo.Price.Discount.Value != null">
                        Discount - {{p.ProductInvoiceInfo.Price.Discount.Value}} 
                        <span *ngIf="p.ProductInvoiceInfo.Price.Discount.Type.ID == 1;">%</span>
                        <span *ngIf="p.ProductInvoiceInfo.Price.Discount.Type.ID == 2;">{{this.CurrentInvoice.Currency.Name}}</span>
                      </p>
                      <p style="height: auto;margin:0;min-height: 16px;line-height: 16px;color: #aaa;font-weight: 400;" *ngIf="p.ProductInvoiceInfo.Price.Discount != null && p.ProductInvoiceInfo.Price.Discount.Value != null && p.ProductInvoiceInfo.Price.Discount.Type.ID == 1;">
                        Initial - {{p.ProductInvoiceInfo.Price.UIUnitPrice}} {{this.CurrentInvoice.Currency.Name}}
                      </p>
        
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 10px;font-weight: 500;height: auto;float: left;min-height: 12px;width: 15%;text-align: right;">
                      <span *ngIf="p.ProductInvoiceInfo.Price.Discount == null || p.ProductInvoiceInfo.Price.Discount.Value == null">{{p.ProductInvoiceInfo.Price.UIQtyPrice}}</span>
                      <span *ngIf="p.ProductInvoiceInfo.Price.Discount != null && p.ProductInvoiceInfo.Price.Discount.Value != null">{{p.ProductInvoiceInfo.Price.UIQtyPriceDiscount}}</span>
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 10px;font-weight: 500;height: auto;float: left;min-height: 12px;width: 10%;text-align: center;">
                      <span>{{p.ProductInvoiceInfo.Price.TotalVATValue}}</span>
                    </td>
                  </tr>
        
                  <tr style="float: left;width: 100%;margin-top: 0px;height: 2px;background: #aaa;">
                    
                  </tr>
        
                </tbody>
              </table>
        
              <table style="width: 100%;">
                <tbody>
                  <tr style="float: left;width: 100%;height: 50px;">
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 7.5%;text-align: center;">
                      {{ 'InvoiceCreator' | translate }}:
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 30%;text-align: left;text-transform: capitalize;">
                      {{this.CurrentInvoice.Details.Agent.Name}}
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 10%;text-align: center;">
                      
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 10%;text-align: center;background: #f6f6f6;">
                      Total:
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 17.5%;text-align: right;background: #f6f6f6;">
                      
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 15%;text-align: right;background: #f6f6f6;">
                         <span>{{CurrentInvoice.Total.UITotalQtyPriceNOVAT.Integer}}</span>
                         <span style="font-size: 12px;">{{CurrentInvoice.Total.UITotalQtyPriceNOVAT.Decimals}}</span> 
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 10%;text-align: center;background: #f6f6f6;">
                      <span>{{CurrentInvoice.Total.UITotalVAT.Integer}}</span>
                      <span style="font-size: 12px;">{{CurrentInvoice.Total.UITotalVAT.Decimals}}</span> 
                    </td>
                  </tr>
                </tbody>
              </table>
        
              <table style="width: 100%;">
                <tbody>
                  <tr style="float: left;width: 100%;height: 50px;">
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 7.5%;text-align: center;">
                      
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 30%;text-align: left;">
                      
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 10%;text-align: center;">
                      
                    </td>
                    <td style="line-height: 12px;font-size: 18px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 15%;text-align: center;">
                      {{ 'TotalPayment' | translate }}
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 12.5%;text-align: right;">
                      
                    </td>
                    <td style="line-height: 12px;font-size: 18px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 25%;text-align: right;padding-right: 10px;">
                      <span>{{CurrentInvoice.Total.UITotalQtyPriceVAT.Integer}}</span>
                      <span>{{CurrentInvoice.Total.UITotalQtyPriceVAT.Decimals}}</span> 
                      <span> {{CurrentInvoice.Currency.Name}}</span>
                    </td>
                  
                  </tr>
                </tbody>
              </table>
        
              <table style="width: 100%;">
                <tbody>
                  <tr style="float: left;width: 100%;height: 50px;">
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 7.5%;text-align: center;">
                      
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 30%;text-align: left;">
                      
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 10%;text-align: center;">
                      
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 15%;text-align: center;">
                      {{ 'PaymentTerms' | translate }}:
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 12.5%;text-align: right;">
                      
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 25%;text-align: right;padding-right: 10px;">
                       {{this.CurrentInvoice.PaymentDueDateUI}}
                    </td>
                  </tr>
                </tbody>
              </table>
        
              <table style="width: 100%;" *ngIf="CurrentInvoice.Details.Agent != null && CurrentInvoice.Details.Agent.ID != null && CurrentInvoice.Details.IsSignedByAgent && this.Products.length > 0;">
                <tbody>
                  <tr style="float: left;width: 100%;height: auto;">
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 7.5%;text-align: center;">
                      
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 30%;text-align: left;">
                  
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 10%;text-align: center;">
                      
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 15%;text-align: center;">
                     
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 12.5%;text-align: right;">
                      <img [src]="this.parent.BackendServiceUrl + this.CurrentInvoice.Details.Agent?.Signature" style="height: auto;
                      width: auto;
                      max-width: 100%;
                      max-height: 100px;"/>
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 25%;text-align: right;padding-right: 10px;">
                    
                    </td>
                  </tr>
                </tbody>
              </table>

              <table style="width: 100%;">
                <tbody>
                  <tr style="float: left;width: 100%;height: auto;">
                    <td style="line-height: 12px;font-size: 12px;padding-top: 10px;font-weight: bold;height: auto;float: left;min-height: 30px;width: 50%;text-align: left;padding-left: 5px;">
                      {{this.CurrentInvoice.Details?.ShippingDetails?.ShippingDetailsTextUI}}
                    </td>
                  </tr>
                </tbody>
              </table>
        
              <table style="width: 100%;">
                <tbody>
                  <tr style="float: left;width: 100%;height: auto;">
                    <td style="line-height: 12px;font-size: 12px;padding-top: 10px;font-weight: 500;height: auto;float: left;min-height: 30px;width: 50%;text-align: left;padding-left: 5px;">
                      {{this.CurrentInvoice.Details.Observations}}
                    </td>
                  </tr>
                </tbody>
              </table>
        
              <table style="width: 100%;background: #f6f6f6;">
                <tbody>
                  <tr>
                    <td style="padding:5px;">
                      <tr style="float: left;width: 100%;height: auto;">
                        <td style="line-height: 12px;font-size: 12px;font-weight: 500;height: auto;float: left;min-height: 12px;width: 100%;text-align: left;">
                          {{this.CurrentInvoice.Company.Name}}
                        </td>
                      </tr>
                      <tr style="float: left;width: 100%;height: auto;">
                        <td style="line-height: 12px;font-size: 12px;height: auto;float: left;min-height: 12px;width: 100%;text-align: left;">
                          {{ 'Telephone' | translate }}: {{this.CurrentInvoice.Details.Agent.Phone}}; Email: {{this.CurrentInvoice.Details.Agent.Email}}
                        </td>
                      </tr>
                      <tr style="float: left;width: 100%;height: auto;" *ngFor="let b of this.CurrentInvoice.Company.Banks">
                        <td *ngFor="let a of b.BankAccounts" style="line-height: 12px;font-size: 12px;height: auto;float: left;min-height: 12px;width: 100%;text-align: left;">
                          {{ 'Partners.PartnerWindow.BankAccountNumber' | translate }} ({{a.Currency.Name}}) : {{a.AccountNumber}}
                        </td>
                      </tr>
                    </td>
                  </tr>
                </tbody>
              </table>
        
              <table style="width: 100%;" *ngIf="this.CurrentInvoice.Details.SignStampSubstituteRows.length > 0;">
                <tbody>
                  <tr>
                    <td style="padding:5px;">
                      <tr style="float: left;width: 100%;height: auto;" *ngFor="let row of this.CurrentInvoice.Details.SignStampSubstituteRows">
                        <td style="line-height: 11px;font-size: 11px;height: auto;float: left;min-height: 12px;width: 100%;text-align: left;">
                          {{row}}
                        </td>
                      </tr>
                    </td>
                  </tr>
                </tbody>
              </table>
        
              <table style="width: 100%;">
                <tbody>
                  <tr style="float: left;width: 100%;height: auto;">
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 7.5%;text-align: center;">
                      
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 30%;text-align: left;">
                  
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 12.5%;text-align: right;">
                     
                    </td>
                    <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 50%;text-align: right;padding-right: 10px;">
                      {{'DocumentGeneratedBySoftware' | translate}}: <a href="https://www.foxcloud.ro" style="color: #254a91;">www.foxcloud.ro</a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
   </div>
</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowEFacturaQuestion">
  <div class="InfoQuestionClose">
    <i class="material-icons" (click)="ShowEFacturaQuestion = false;">close</i>
  </div>
  <div class="InfoQuestionTitle">
    {{ 'ShowEFacturaQuestion' | translate }}
  </div>
  <div class="InfoQuestionBody">
    {{ 'ShowEFacturaQuestionDescription' | translate }}
  </div>

  <div class="InfoQuestionCommands">
    <button [disabled]="this.parent.loading || this.DocumentBodyLoading" class="ModernButton ModernButtonSecondary InfoQuestionButton" (click)="ShowEFacturaQuestion = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
    <button [disabled]="this.parent.loading || this.DocumentBodyLoading" class="ModernButton ModernButtonAccent InfoQuestionButton" (click)="UploadEFactura();">{{ 'Send' | translate }}</button>
  </div>
</div>

<!-- Export Panel Overlay -->
<div class="export-panel-overlay" *ngIf="ShowPrepareInvoiceForExportStepZero == true;"
     (click)="ShowPrepareInvoiceForExportStepZero = false;"></div>

<div class="export-panel" *ngIf="ShowPrepareInvoiceForExportStepZero == true;">
  <div class="export-panel__header">
    <h2 class="export-panel__title">{{ 'PrepareInvoiceForExport' | translate }}</h2>
    <button class="export-panel__close" (click)="ShowPrepareInvoiceForExportStepZero = false;">×</button>
  </div>

  <!-- Tab Navigation -->
  <div class="export-panel__tabs">
    <button class="export-panel__tab"
            [class.export-panel__tab--active]="ExportPanelTab === 'invoice'"
            (click)="ExportPanelTab = 'invoice';">
      {{ 'CurrentInvoice' | translate }}
    </button>
    <button class="export-panel__tab"
            [class.export-panel__tab--active]="ExportPanelTab === 'missing_descriptions'"
            (click)="ExportPanelTab = 'missing_descriptions'; GetHSCodesWithoutDescriptions();">
      {{ 'HSCodesMissingDescriptions' | translate }}
    </button>
  </div>

  <!-- Tab: Current Invoice -->
  <div class="export-panel__body" *ngIf="ExportPanelTab === 'invoice'">
    <!-- Global HS Code Search -->
    <div class="global-search">
      <div class="global-search__checkbox">
        <mat-checkbox [(ngModel)]="AllSelected" (change)="SelectAll();"></mat-checkbox>
        <span class="global-search__label">{{'SelectAll' | translate}}</span>
      </div>
      <div class="global-search__input">
        <input type="text"
               class="hs-search-input"
               placeholder="{{'SearchHSCode' | translate}}"
               [(ngModel)]="this.HSFilter.Code"
               (ngModelChange)="this.hsSearchTermUpdate.next($event)"
               (blur)="ValidateAndSanitizeHSCodeGlobal()" />
        <button *ngIf="this.HSFilter.Code?.length > 0"
                class="hs-search-clear"
                (click)="this.HSFilter.Code = ''; this.HSCodes = [];">
          <i class="material-icons">close</i>
        </button>
        <div class="hs-dropdown" *ngIf="this.HSCodes.length > 0">
          <div class="hs-dropdown__item"
               *ngFor="let h of this.HSCodes;"
               (click)="SelectHSCodeForAll(h);">
            <span class="hs-code"><span class="hscode-valid">{{getHSCodeParts(h.Code).valid}}</span><span class="hscode-excess" *ngIf="getHSCodeParts(h.Code).hasExcess">{{getHSCodeParts(h.Code).excess}}</span></span>
            <span class="hs-description">{{h.Descriptions[0]?.Description}}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Products List -->
    <div class="product-list" *ngIf="this.CurrentInvoice.Products?.length > 0; else emptyState">
      <div class="product-card"
           [class.product-card--dropdown-open]="p.HSCodeSearchResults?.length > 0"
           *ngFor="let p of this.CurrentInvoice.Products; let i = index;">

        <div class="product-card__header">
          <mat-checkbox [(ngModel)]="p.IsSelected"
                        (change)="CheckIfAnyChecked();"
                        (dblclick)="onProductDoubleClick(i)"></mat-checkbox>
          <span class="product-index">#{{i + 1}}</span>
          <span class="product-name">{{p.ProductInvoiceInfo.Name}}</span>
          <span class="product-code" *ngIf="p.ProductInvoiceInfo.Code">{{p.ProductInvoiceInfo.Code}}</span>
        </div>

        <div class="product-meta">
          <span>{{p.ProductInvoiceInfo.Quantity}} {{p.ProductInvoiceInfo.MeasuringUnit.Name}}</span>
          <span>{{p.ProductInvoiceInfo.Price.UIUnitPrice}} {{this.CurrentInvoice.Currency.Name}}</span>
        </div>

        <ul class="description-list" *ngIf="p.ProductInvoiceInfo.DescriptionRows?.length > 0">
          <li *ngFor="let row of p.ProductInvoiceInfo.DescriptionRows;">{{row}}</li>
        </ul>

        <div class="product-hs-search">
          <input type="text"
                 class="hs-search-input hs-search-input--small"
                 placeholder="{{'SearchHSCode' | translate}}"
                 [(ngModel)]="p.HSCodeSearchTerm"
                 (ngModelChange)="onProductHSSearchChange($event, i)"
                 (blur)="ValidateAndSanitizeHSCodeProduct(i)"
                 [disabled]="AllSelected" />
          <button *ngIf="p.HSCodeSearchTerm?.length > 0 && !AllSelected"
                  class="hs-search-clear hs-search-clear--small"
                  (click)="clearProductHSSearch(i);">
            <i class="material-icons">close</i>
          </button>
          <div class="hs-dropdown hs-dropdown--product" *ngIf="p.HSCodeSearchResults?.length > 0 && !AllSelected">
            <div class="hs-dropdown__item"
                 *ngFor="let h of p.HSCodeSearchResults;"
                 (click)="SelectHSCodeForProduct(h, i);">
              <span class="hs-code"><span class="hscode-valid">{{getHSCodeParts(h.Code).valid}}</span><span class="hscode-excess" *ngIf="getHSCodeParts(h.Code).hasExcess">{{getHSCodeParts(h.Code).excess}}</span></span>
              <span class="hs-description">{{h.Descriptions[0]?.Description}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ng-template #emptyState>
      <div class="empty-state">
        {{ 'NoProductsToExport' | translate }}
      </div>
    </ng-template>
  </div>

  <!-- Tab: HSCodes Missing Descriptions -->
  <div class="export-panel__body" *ngIf="ExportPanelTab === 'missing_descriptions'">
    <div class="missing-descriptions-list" *ngIf="!HSCodesWithoutDescriptionsLoading && HSCodesWithoutDescriptions?.length > 0">
      <div class="missing-descriptions-item" *ngFor="let h of HSCodesWithoutDescriptions; let mdIdx = index;">
        <div class="missing-descriptions-item__code">
          <span class="missing-descriptions-item__index">{{mdIdx + 1}}</span>
          <span class="hs-code"><span class="hscode-valid">{{getHSCodeParts(h.Code).valid}}</span><span class="hscode-excess" *ngIf="getHSCodeParts(h.Code).hasExcess">{{getHSCodeParts(h.Code).excess}}</span></span>
          <span class="missing-descriptions-item__country" *ngIf="h.ImportingCountry?.Name">{{h.ImportingCountry.Name}}</span>
        </div>
        <div class="missing-descriptions-item__inputs">
          <div class="missing-descriptions-item__input-group">
            <label class="missing-descriptions-item__label">EN</label>
            <input type="text"
                   class="hs-search-input"
                   placeholder="{{ 'EnterDescription' | translate }} (English)"
                   [(ngModel)]="h.NewDescriptionEN"
                   [disabled]="h.Saving" />
          </div>
          <div class="missing-descriptions-item__input-group">
            <label class="missing-descriptions-item__label">RO</label>
            <input type="text"
                   class="hs-search-input"
                   placeholder="{{ 'EnterDescription' | translate }} (Română)"
                   [(ngModel)]="h.NewDescriptionRO"
                   [disabled]="h.Saving" />
          </div>
          <button class="ModernButton ModernButtonPrimary missing-descriptions-item__save"
                  [disabled]="h.Saving || (!h.NewDescriptionEN && !h.NewDescriptionRO)"
                  (click)="SaveHSCodeDescriptions(h);">
            <span *ngIf="!h.Saving">{{ 'Save' | translate }}</span>
            <mat-spinner *ngIf="h.Saving" [diameter]="16"></mat-spinner>
          </button>
        </div>
      </div>
    </div>

    <div class="empty-state" *ngIf="!HSCodesWithoutDescriptionsLoading && HSCodesWithoutDescriptions?.length === 0">
      {{ 'NoHSCodesMissingDescriptions' | translate }}
    </div>

    <div class="loading-state" *ngIf="HSCodesWithoutDescriptionsLoading">
      <mat-spinner [diameter]="32"></mat-spinner>
      <span>{{ 'Loading' | translate }}...</span>
    </div>
  </div>

  <!-- Footer for Invoice Tab -->
  <div class="export-panel__footer" *ngIf="ExportPanelTab === 'invoice'">
    <button class="ModernButton ModernButtonSuccess"
            [disabled]="AutoAssociateHSCodesLoading || !CurrentInvoice?.ID"
            (click)="AutoAssociateHSCodes();"
            matTooltip="{{ 'AutoAssociateHSCodesDescription' | translate }}">
      <span *ngIf="!AutoAssociateHSCodesLoading">{{ 'AutoAssociateHSCodes' | translate }}</span>
      <mat-spinner *ngIf="AutoAssociateHSCodesLoading" [diameter]="18"></mat-spinner>
    </button>
    <button class="ModernButton ModernButtonPrimary"
            [disabled]="PrepareInvoiceForExportLoading || HSCodesAssiciationLoading"
            (click)="AssociateInvoiceProductsHSCodes();">
      <span *ngIf="!HSCodesAssiciationLoading">{{ 'AssociateRealHSCodes' | translate }}</span>
      <mat-spinner *ngIf="HSCodesAssiciationLoading" [diameter]="18"></mat-spinner>
    </button>
    <button class="btn-next"
            (click)="PrepareInvoiceForExportStepOne();"
            [disabled]="PrepareInvoiceForExportLoading || HSCodesAssiciationLoading">
      <span *ngIf="!PrepareInvoiceForExportLoading">{{ 'Next' | translate }}</span>
      <mat-spinner *ngIf="PrepareInvoiceForExportLoading" [diameter]="18"></mat-spinner>
    </button>
  </div>

  <!-- Footer for Missing Descriptions Tab -->
  <div class="export-panel__footer" *ngIf="ExportPanelTab === 'missing_descriptions'">
    <span class="export-panel__footer-info">
      {{ HSCodesWithoutDescriptions?.length || 0 }} {{ 'HSCodesMissingDescriptionsCount' | translate }}
    </span>
    <button class="ModernButton ModernButtonPrimary"
            [disabled]="HSCodesWithoutDescriptionsLoading"
            (click)="GetHSCodesWithoutDescriptions();">
      <span *ngIf="!HSCodesWithoutDescriptionsLoading">{{ 'Refresh' | translate }}</span>
      <mat-spinner *ngIf="HSCodesWithoutDescriptionsLoading" [diameter]="18"></mat-spinner>
    </button>
  </div>
</div>

<!-- Export Panel Overlay - Step One -->
<div class="export-panel-overlay" *ngIf="ShowPrepareInvoiceForExportStepOne == true;"
     (click)="ShowPrepareInvoiceForExportStepOne = false;"></div>

<div class="export-panel" *ngIf="ShowPrepareInvoiceForExportStepOne == true;">
  <div class="export-panel__header">
    <h2 class="export-panel__title">{{ 'PrepareInvoiceForExportStepOne' | translate }}</h2>
    <button class="export-panel__close" (click)="ShowPrepareInvoiceForExportStepOne = false;">×</button>
  </div>

  <div class="export-panel__body">
    <div class="customs-forms-list" *ngIf="CustomsForms?.length > 0; else noFormsState">

      <!-- Select All for Customs Forms -->
      <div class="customs-select-all">
        <mat-checkbox [(ngModel)]="AllCustomsFormsSelected"
                      (change)="SelectAllCustomsForms();"></mat-checkbox>
        <span class="customs-select-all__label">{{'SelectAll' | translate}}</span>
        <button class="ModernButton ModernButtonPrimary"
                style="margin-left: auto;"
                [disabled]="PrepareCustomsFormsDocumentsLoading"
                (click)="PrepareCustomsFormsDocuments(null, true)">
          <span *ngIf="!(PrepareCustomsFormsDocumentsLoading && PrepareCustomsFormsDocumentsLoadingFormId === 'all')">{{ 'PrepareAllSelected' | translate }}</span>
          <mat-spinner *ngIf="PrepareCustomsFormsDocumentsLoading && PrepareCustomsFormsDocumentsLoadingFormId === 'all'" [diameter]="18"></mat-spinner>
        </button>
      </div>

      <div class="customs-form-item"
           *ngFor="let form of CustomsForms; let i = index;">

        <div class="customs-form-header">
          <mat-checkbox [(ngModel)]="form.IsSelected"></mat-checkbox>
          <span class="customs-form-name">{{form.Name}}</span>
          <button class="ModernButton ModernButtonPrimary"
                  style="margin-right: 8px;"
                  [disabled]="PrepareCustomsFormsDocumentsLoading"
                  (click)="PrepareCustomsFormsDocuments(form)">
            <span *ngIf="!(PrepareCustomsFormsDocumentsLoading && PrepareCustomsFormsDocumentsLoadingFormId === form.ID)">{{ 'PrepareForm' | translate }}</span>
            <mat-spinner *ngIf="PrepareCustomsFormsDocumentsLoading && PrepareCustomsFormsDocumentsLoadingFormId === form.ID" [diameter]="16"></mat-spinner>
          </button>
          <button *ngIf="form.Documents && form.Documents.length > 0"
                  mat-icon-button
                  class="download-btn"
                  (click)="downloadCustomsForm(form)"
                  matTooltip="Download Form">
            <i class="material-icons">download</i>
          </button>
        </div>
      </div>
    </div>

    <ng-template #noFormsState>
      <div class="empty-state">
        {{ 'NoCustomsFormsAvailable' | translate }}
      </div>
    </ng-template>

    <!-- Auto Evaluation Declaration Section -->
    <div class="customs-form-item" style="margin-top: 16px;">
      <div class="customs-form-header">
        <mat-checkbox [(ngModel)]="AutoEvaluationIsSelected"></mat-checkbox>
        <span class="customs-form-name">{{ 'AutoEvaluationDeclaration' | translate }}</span>
        <button class="ModernButton ModernButtonPrimary"
                style="margin-right: 8px;"
                [disabled]="ExportAutoEvaluationLoading"
                (click)="ExportAutoEvaluation(this.CurrentInvoice)">
          <span *ngIf="!ExportAutoEvaluationLoading">{{ 'PrepareForm' | translate }}</span>
          <mat-spinner *ngIf="ExportAutoEvaluationLoading" [diameter]="16"></mat-spinner>
        </button>
      </div>

      <!-- Display generated auto-evaluation documents -->
      <div *ngIf="AutoEvaluationDocuments?.length > 0" class="auto-evaluation-documents" style="margin-top: 12px; padding-left: 36px;">
        <div *ngFor="let doc of AutoEvaluationDocuments"
             class="auto-eval-doc-item"
             style="display: flex; align-items: center; padding: 6px 0; font-size: 13px; color: #1a3a5c;">
          <i class="material-icons" style="font-size: 18px; color: #32aa3a; margin-right: 8px;">check_circle</i>
          <span style="flex: 1;">{{ doc.Name }}</span>
          <button mat-icon-button
                  class="download-btn"
                  (click)="downloadAutoEvaluationDocument(doc)"
                  matTooltip="Download">
            <i class="material-icons">download</i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="export-panel__footer">
    <button class="ModernButton ModernButtonSecondary"
            (click)="ShowPrepareInvoiceForExportStepOne = false; ShowPrepareInvoiceForExportStepZero = true;">
      {{ 'Back' | translate }}
    </button>
    <button class="ModernButton ModernButtonPrimary"
            style="margin-left: 8px;"
            [disabled]="EmailToCarrierLoading"
            (click)="OpenEmailToCarrierModal();">
      <mat-spinner *ngIf="EmailToCarrierLoading" [diameter]="18" style="margin-right: 6px;"></mat-spinner>
      <i class="material-icons" *ngIf="!EmailToCarrierLoading" style="font-size: 18px; margin-right: 6px;">email</i>
      {{ 'EmailToCarrier' | translate }}
    </button>
    <button class="btn-next"
            [disabled]="DownloadAllFormsLoading"
            (click)="DownloadAllFormsAndFinish();">
      <mat-spinner *ngIf="DownloadAllFormsLoading" [diameter]="18" style="margin-right: 6px;"></mat-spinner>
      {{ 'DownloadAndFinish' | translate }}
    </button>
  </div>
</div>

<!-- Export Validation Errors Container (above export panel z-index) -->
<div class="export-panel-overlay" *ngIf="ShowExportValidationErrors" style="z-index: 100000;"
     (click)="CloseExportValidationErrors()"></div>
<div *ngIf="ShowExportValidationErrors"
     style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 100001;
            background: #fff; border-radius: 16px; box-shadow: 0 20px 60px rgba(0,0,0,0.3);
            max-width: 620px; width: 92%; max-height: 80vh; display: flex; flex-direction: column;
            overflow: hidden; animation: exportPanelPopIn 0.15s cubic-bezier(0.2, 0.9, 0.3, 1.05);">

  <!-- Header -->
  <div style="display: flex; align-items: center; justify-content: space-between; padding: 16px 20px; border-bottom: 1px solid rgba(0,0,0,0.06); background: #fff5f5;">
    <div style="display: flex; align-items: center; gap: 10px;">
      <i class="material-icons" style="font-size: 28px; color: #ff3b30;">error_outline</i>
      <span style="font-size: 15px; font-weight: 700; color: #1c1c1e;">{{'ExportValidationFailed' | translate}}</span>
    </div>
    <i class="material-icons" style="cursor: pointer; color: #8e8e93; font-size: 20px;" (click)="CloseExportValidationErrors();">close</i>
  </div>

  <!-- Body (scrollable) -->
  <div style="flex: 1; overflow-y: auto; padding: 16px 20px;">
    <p style="font-size: 12px; color: #8e8e93; margin: 0 0 16px 0;">{{'ExportValidationMessage' | translate}}</p>

    <!-- Product Error Cards -->
    <div style="display: flex; flex-direction: column; gap: 8px;">
      <div *ngFor="let err of ExportValidationErrors; let ei = index;"
           style="border: 1px solid rgba(255,59,48,0.15); border-radius: 10px; overflow: hidden; background: #fffafa; padding: 12px 14px;">

        <!-- Product header -->
        <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 8px;">
          <span style="font-size: 11px; font-weight: 700; color: #ff3b30; background: rgba(255,59,48,0.08); border-radius: 50%; width: 22px; height: 22px; display: flex; align-items: center; justify-content: center;">{{ei + 1}}</span>
          <span style="font-size: 13px; font-weight: 600; color: #1c1c1e; flex: 1;">{{err.ProductName}}</span>
          <span *ngIf="err.ProductCode" style="font-size: 11px; color: #8e8e93; font-family: monospace;">{{err.ProductCode}}</span>
        </div>

        <!-- Missing items -->
        <div style="display: flex; flex-direction: column; gap: 4px; padding-left: 30px;">
          <div *ngIf="err.MissingHSCode" style="display: flex; align-items: center; gap: 6px;">
            <i class="material-icons" style="font-size: 14px; color: #ff3b30;">close</i>
            <span style="font-size: 12px; color: #ff3b30; font-weight: 500;">{{'ExportMissingHSCode' | translate}}</span>
          </div>
          <div *ngIf="err.MissingCOO" style="display: flex; align-items: center; gap: 6px;">
            <i class="material-icons" style="font-size: 14px; color: #ff3b30;">close</i>
            <span style="font-size: 12px; color: #ff3b30; font-weight: 500;">{{'ExportMissingCOO' | translate}}</span>
          </div>
          <div *ngIf="err.MissingLanguageDescription" style="display: flex; align-items: center; gap: 6px;">
            <i class="material-icons" style="font-size: 14px; color: #ff3b30;">close</i>
            <span style="font-size: 12px; color: #ff3b30; font-weight: 500;">{{'ExportMissingLangDescription' | translate}} ({{err.MissingLanguageCode}})</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div style="display: flex; justify-content: flex-end; gap: 12px; padding: 14px 20px; border-top: 1px solid rgba(0,0,0,0.06);">
    <button class="ModernButton ModernButtonSecondary" (click)="CloseExportValidationErrors();">
      <i class="material-icons" style="font-size: 16px; margin-right: 4px;">close</i> {{'Close' | translate}}
    </button>
  </div>
</div>

<!-- Export Already Sent Confirmation (above export panel z-index) -->
<div class="export-panel-overlay" *ngIf="ShowExportAlreadySentConfirm" style="z-index: 100000;"
     (click)="CancelResendExportEmail()"></div>
<div *ngIf="ShowExportAlreadySentConfirm"
     style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 100001;
            background: #fff; border-radius: 16px; box-shadow: 0 20px 60px rgba(0,0,0,0.3);
            max-width: 560px; width: 92%; max-height: 80vh; display: flex; flex-direction: column;
            overflow: hidden; animation: exportPanelPopIn 0.15s cubic-bezier(0.2, 0.9, 0.3, 1.05);">

  <!-- Header -->
  <div style="display: flex; align-items: center; justify-content: space-between; padding: 16px 20px; border-bottom: 1px solid rgba(0,0,0,0.06);">
    <div style="display: flex; align-items: center; gap: 10px;">
      <i class="material-icons" style="font-size: 28px; color: #ff9500;">warning_amber</i>
      <span style="font-size: 15px; font-weight: 700; color: #1c1c1e;">{{'ExportAlreadySentTitle' | translate}}</span>
    </div>
    <i class="material-icons" style="cursor: pointer; color: #8e8e93; font-size: 20px;" (click)="CancelResendExportEmail();">close</i>
  </div>

  <!-- Body (scrollable) -->
  <div style="flex: 1; overflow-y: auto; padding: 16px 20px;">
    <p style="font-size: 12px; color: #8e8e93; margin: 0 0 16px 0;">{{'ExportAlreadySentMessage' | translate}}</p>

    <!-- History Cards -->
    <div style="display: flex; flex-direction: column; gap: 8px;">
      <div *ngFor="let h of ExportSentHistory; let hi = index;"
           style="border: 1px solid rgba(0,0,0,0.08); border-radius: 10px; overflow: hidden; background: #fafafa;">

        <!-- Collapsed Header (always visible, clickable) -->
        <div (click)="ToggleExportHistoryItem(h)"
             style="display: flex; align-items: center; gap: 10px; padding: 10px 14px; cursor: pointer; transition: background 0.15s;"
             [style.background]="h.IsExpanded ? 'rgba(0,122,255,0.04)' : 'transparent'">
          <i class="material-icons" style="font-size: 18px; color: #007aff; transition: transform 0.2s;"
             [style.transform]="h.IsExpanded ? 'rotate(90deg)' : 'rotate(0deg)'">chevron_right</i>
          <span style="font-size: 11px; font-weight: 600; color: #8e8e93; min-width: 18px;">{{hi + 1}}</span>
          <span style="font-size: 12px; font-weight: 600; color: #1c1c1e; flex: 1;">{{h.EventRegister | date:'dd MMM yyyy, HH:mm'}}</span>
          <span style="font-size: 10px; color: #fff; background: #34c759; padding: 2px 8px; border-radius: 20px; font-weight: 600;">
            <i class="material-icons" style="font-size: 11px; vertical-align: middle;">check</i> {{'Sent' | translate}}
          </span>
          <span *ngIf="h.AttachmentCount > 0" style="font-size: 10px; color: #8e8e93;">
            <i class="material-icons" style="font-size: 13px; vertical-align: middle;">attach_file</i> {{h.AttachmentCount}}
          </span>
        </div>

        <!-- Expanded Details -->
        <div *ngIf="h.IsExpanded" style="padding: 0 14px 14px 42px; border-top: 1px solid rgba(0,0,0,0.04);">

          <!-- From -->
          <div style="display: flex; align-items: flex-start; gap: 6px; margin-top: 10px;">
            <span style="font-size: 10px; font-weight: 700; color: #8e8e93; min-width: 50px; text-transform: uppercase;">{{'From' | translate}}</span>
            <span style="font-size: 12px; color: #1c1c1e;">{{h.FromMail}}</span>
          </div>

          <!-- To -->
          <div style="display: flex; align-items: flex-start; gap: 6px; margin-top: 6px;">
            <span style="font-size: 10px; font-weight: 700; color: #8e8e93; min-width: 50px; text-transform: uppercase;">{{'To' | translate}}</span>
            <div style="display: flex; flex-wrap: wrap; gap: 4px;">
              <span *ngFor="let email of h.ToEmailsList"
                    style="font-size: 11px; color: #1a3a5c; background: #e8f0f8; padding: 2px 8px; border-radius: 20px;">{{email}}</span>
            </div>
          </div>

          <!-- Subject -->
          <div style="display: flex; align-items: flex-start; gap: 6px; margin-top: 6px;">
            <span style="font-size: 10px; font-weight: 700; color: #8e8e93; min-width: 50px; text-transform: uppercase;">{{'Subject' | translate}}</span>
            <span style="font-size: 12px; color: #1c1c1e; font-weight: 500;">{{h.Subject}}</span>
          </div>

          <!-- Body preview -->
          <div style="margin-top: 8px; padding: 8px 10px; background: #fff; border: 1px solid rgba(0,0,0,0.06); border-radius: 6px; max-height: 100px; overflow-y: auto;">
            <pre style="font-size: 11px; color: #3c3c43; white-space: pre-wrap; word-break: break-word; margin: 0; font-family: 'Segoe UI', sans-serif;">{{h.Body}}</pre>
          </div>

          <!-- Attachments count -->
          <div *ngIf="h.AttachmentCount > 0" style="display: flex; align-items: center; gap: 6px; margin-top: 8px;">
            <i class="material-icons" style="font-size: 14px; color: #8e8e93;">attach_file</i>
            <span style="font-size: 11px; color: #8e8e93;">{{h.AttachmentCount}} {{'Attachments' | translate}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div style="display: flex; justify-content: flex-end; gap: 12px; padding: 14px 20px; border-top: 1px solid rgba(0,0,0,0.06);">
    <button class="ModernButton ModernButtonSecondary" (click)="CancelResendExportEmail();">
      <i class="material-icons" style="font-size: 16px; margin-right: 4px;">close</i> {{'Cancel' | translate}}
    </button>
    <button class="ModernButton ModernButtonPrimary" (click)="ConfirmResendExportEmail();">
      <i class="material-icons" style="font-size: 16px; margin-right: 4px;">send</i> {{'ResendAnyway' | translate}}
    </button>
  </div>
</div>

<!-- Email to Carrier Modal -->
<div class="export-panel-overlay" *ngIf="ShowEmailToCarrierContainer"
     (click)="CloseEmailToCarrierModal()"></div>

<div class="export-panel email-modal" *ngIf="ShowEmailToCarrierContainer" style="max-width: 600px;">
  <div class="export-panel__header">
    <h2 class="export-panel__title">{{ 'EmailToCarrierTitle' | translate }}</h2>
    <button class="export-panel__close" (click)="CloseEmailToCarrierModal()">×</button>
  </div>

  <div class="export-panel__body" style="max-height: 60vh; overflow-y: auto;">
    <!-- Sender Email Selection -->
    <p class="EmailNotificationBodyTitle">{{ 'SendingEmail' | translate }}:</p>
    <div class="MinimalistRadioOption" *ngFor="let e of CarrierSMTPEmails" (click)="SelectCarrierSMTPEmail(e)">
      <span>{{e.Email}}</span>
      <i class="material-icons" *ngIf="e.IsDefault == true">radio_button_checked</i>
      <i class="material-icons" *ngIf="e.IsDefault == false">radio_button_unchecked</i>
    </div>

    <!-- Recipients -->
    <p class="EmailNotificationBodyTitle" style="margin-top: 25px;">{{ 'CarrierRecipients' | translate }}:</p>
    <div class="carrier-recipients-list" style="display: flex; flex-direction: column; gap: 8px;">
      <!-- Existing Recipients -->
      <div class="carrier-recipient-item" *ngFor="let e of CarrierCurrentSupportContact?.Emails"
           style="display: flex; align-items: center; padding: 8px 12px; background: #f8fbfe; border-radius: 8px; gap: 8px;">
        <!-- Select/Deselect Toggle -->
        <mat-checkbox [(ngModel)]="e.IsSelected" style="flex-shrink: 0;"></mat-checkbox>

        <!-- Email Display/Edit -->
        <div style="flex: 1; display: flex; align-items: center;">
          <span *ngIf="!e.IsEditing" style="font-size: 13px; color: #1a3a5c;">{{e.Email}}</span>
          <input *ngIf="e.IsEditing"
                 type="email"
                 [(ngModel)]="e.EditValue"
                 class="MinimalistInput"
                 style="height: 32px; font-size: 13px; flex: 1;"
                 (keydown.enter)="SaveCarrierRecipientEmail(e)"
                 (keydown.escape)="CancelEditCarrierRecipient(e)">
        </div>

        <!-- Action Buttons -->
        <div style="display: flex; gap: 4px; flex-shrink: 0;">
          <!-- Edit Button -->
          <button *ngIf="!e.IsEditing"
                  class="icon-btn"
                  style="background: none; border: none; cursor: pointer; padding: 4px; color: #1a3a5c;"
                  (click)="StartEditCarrierRecipient(e)"
                  matTooltip="{{ 'Edit' | translate }}">
            <i class="material-icons" style="font-size: 18px;">edit</i>
          </button>
          <!-- Save Button -->
          <button *ngIf="e.IsEditing"
                  class="icon-btn"
                  style="background: none; border: none; cursor: pointer; padding: 4px; color: #4caf50;"
                  [disabled]="CarrierRecipientSaving"
                  (click)="SaveCarrierRecipientEmail(e)"
                  matTooltip="{{ 'Save' | translate }}">
            <i class="material-icons" style="font-size: 18px;">check</i>
          </button>
          <!-- Cancel Edit Button -->
          <button *ngIf="e.IsEditing"
                  class="icon-btn"
                  style="background: none; border: none; cursor: pointer; padding: 4px; color: #f44336;"
                  (click)="CancelEditCarrierRecipient(e)"
                  matTooltip="{{ 'Cancel' | translate }}">
            <i class="material-icons" style="font-size: 18px;">close</i>
          </button>
          <!-- Delete Button -->
          <button *ngIf="!e.IsEditing"
                  class="icon-btn"
                  style="background: none; border: none; cursor: pointer; padding: 4px; color: #f44336;"
                  [disabled]="CarrierRecipientSaving"
                  (click)="DeleteCarrierRecipientEmail(e)"
                  matTooltip="{{ 'Delete' | translate }}">
            <i class="material-icons" style="font-size: 18px;">delete</i>
          </button>
        </div>
      </div>

      <!-- Add New Recipient -->
      <div class="carrier-recipient-add"
           style="display: flex; align-items: center; padding: 8px 12px; background: #e8f4fd; border-radius: 8px; border: 1px dashed #1a3a5c; gap: 8px;">
        <i class="material-icons" style="color: #1a3a5c; font-size: 20px;">person_add</i>
        <input type="email"
               [(ngModel)]="NewCarrierRecipientEmail"
               class="MinimalistInput"
               style="height: 32px; font-size: 13px; flex: 1; background: white;"
               placeholder="{{ 'EnterNewRecipientEmail' | translate }}"
               (keydown.enter)="AddCarrierRecipientEmail()">
        <button class="ModernButton ModernButtonPrimary"
                style="height: 32px; padding: 0 12px; font-size: 12px;"
                [disabled]="!NewCarrierRecipientEmail || CarrierRecipientSaving"
                (click)="AddCarrierRecipientEmail()">
          <mat-spinner *ngIf="CarrierRecipientSaving" [diameter]="14" style="margin-right: 4px;"></mat-spinner>
          <i class="material-icons" *ngIf="!CarrierRecipientSaving" style="font-size: 16px;">add</i>
        </button>
      </div>

      <!-- Empty State -->
      <div *ngIf="!CarrierCurrentSupportContact?.Emails?.length && !NewCarrierRecipientEmail"
           class="empty-state"
           style="padding: 12px; font-size: 13px; color: #666; text-align: center;">
        {{ 'NoCarrierContactsFound' | translate }}
      </div>
    </div>

    <!-- Subject -->
    <div class="MinimalistInputContainer" style="margin-top: 20px;">
      <label class="MinimalistInputLabel">{{ 'Subject' | translate }}</label>
      <input autocomplete="off" [(ngModel)]="CarrierEmailSubject" class="MinimalistInput" type="text">
    </div>

    <!-- Message Body -->
    <div class="MinimalistInputContainer" style="margin-top: 20px;">
      <label class="MinimalistInputLabel">{{ 'YourMessage' | translate }}</label>
      <textarea autocomplete="off" [(ngModel)]="CarrierEmailBody" class="MinimalistTextarea" rows="8"></textarea>
    </div>

    <!-- Attachments -->
    <p class="EmailNotificationBodyTitle" style="margin-top: 25px;">{{ 'SelectAttachments' | translate }}:</p>
    <div class="attachments-list" style="display: flex; flex-direction: column; gap: 8px;">
      <div class="attachment-item" *ngFor="let a of CarrierEmailAttachments"
           style="display: flex; align-items: center; padding: 8px 12px; background: #f8fbfe; border-radius: 8px; cursor: pointer;"
           (click)="ToggleCarrierAttachment(a)">
        <mat-checkbox [(ngModel)]="a.IsSelected" (click)="$event.stopPropagation()"></mat-checkbox>
        <i class="material-icons" style="margin-left: 8px; color: #1a3a5c;">attach_file</i>
        <span style="margin-left: 8px; font-size: 13px; color: #1a3a5c;">{{a.Name}}</span>
      </div>
    </div>
  </div>

  <div class="export-panel__footer" style="justify-content: flex-end; gap: 12px;">
    <button class="ModernButton ModernButtonSecondary"
            [disabled]="EmailToCarrierLoading"
            (click)="CloseEmailToCarrierModal()">
      <i class="material-icons" style="font-size: 18px; margin-right: 6px;">close</i>
      {{ 'Cancel' | translate }}
    </button>
    <button class="ModernButton ModernButtonPrimary"
            [disabled]="EmailToCarrierLoading"
            (click)="SendExportDeclarationEmail()">
      <mat-spinner *ngIf="EmailToCarrierLoading" [diameter]="18" style="margin-right: 8px;"></mat-spinner>
      <i class="material-icons" *ngIf="!EmailToCarrierLoading" style="font-size: 18px; margin-right: 6px;">send</i>
      {{ 'SendEmail' | translate }}
    </button>
  </div>
</div>

<!-- Apple-style Delete Confirmation Popup -->
<div class="apple-confirm-overlay" *ngIf="ShowDeleteRecipientConfirm" (click)="CancelDeleteRecipient()"></div>
<div class="apple-confirm-popup" *ngIf="ShowDeleteRecipientConfirm">
  <div class="apple-confirm-icon">
    <i class="material-icons">delete_outline</i>
  </div>
  <div class="apple-confirm-title">{{ 'DeleteRecipient' | translate }}</div>
  <div class="apple-confirm-message">{{ 'DeleteRecipientConfirmMessage' | translate }}</div>
  <div class="apple-confirm-email">{{ RecipientToDelete?.Email }}</div>
  <div class="apple-confirm-actions">
    <button class="apple-confirm-btn apple-confirm-btn-cancel" (click)="CancelDeleteRecipient()">
      {{ 'Cancel' | translate }}
    </button>
    <button class="apple-confirm-btn apple-confirm-btn-delete"
            [disabled]="CarrierRecipientSaving"
            (click)="ConfirmDeleteRecipient()">
      <mat-spinner *ngIf="CarrierRecipientSaving" [diameter]="12"></mat-spinner>
      <span *ngIf="!CarrierRecipientSaving">{{ 'Delete' | translate }}</span>
    </button>
  </div>
</div>

<div class="MainContainer animated fadeIn" *ngIf="!this.loading">

    <div class="overlay" *ngIf="ShowPrepareInvoiceForExportStepOne || ShowPrepareInvoiceForExportStepZero || ShowEmailToCarrierContainer || ShowDeleteBoxQuestion || showAccountingSeriesError || ShowSubordronateDocumentsWarning || ShowSubordonateProductsAdjustment || ShowDocumentError || ShowProformaInvoiceConvertorQuestion || showInvoiceVisualizer || showProductDiscountContainer || showDocumentDiscountContainer"></div>

    <div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeleteBoxQuestion">
      <div class="InfoQuestionClose">
        <i class="material-icons" (click)="ShowDeleteBoxQuestion = false; CurrentBox = null;">close</i>
      </div>
      <div class="InfoQuestionTitle">
        {{ 'Configuration.DeleteQuestion' | translate }}
      </div>
      <div class="InfoQuestionBody">
        {{ 'Configuration.DeleteQuestionDescription' | translate }}
      </div>

      <div class="InfoQuestionCommands">
        <button [disabled]="this.parent.loading" class="ModernButton ModernButtonSecondary InfoQuestionButton" (click)="ShowDeleteBoxQuestion = false; CurrentBox = null;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
        <button [disabled]="this.parent.loading" class="ModernButton ModernButtonDanger InfoQuestionButton" (click)="ShowDeleteBoxQuestion = false;DeleteBox(CurrentBox);">{{ 'Configuration.DeleteYesButton' | translate }}</button>
      </div>
    </div>

    <div class="InfoQuestion animated fadeInDown" *ngIf="showAccountingSeriesError">
      <div class="InfoQuestionClose">
        <i class="material-icons" (click)="this.parent.RedirectToURL('/dashboard/settings/mycompany');">close</i>
      </div>
      <div class="InfoQuestionTitle">
        {{ 'Configuration.AccountingSeriesDocumentError' | translate }}
      </div>
      <div class="InfoQuestionBody">
        {{ 'Configuration.AccountingSeriesDocumentErrorDescription' | translate }}
      </div>

      <div class="InfoQuestionCommands">
        <button class="ModernButton ModernButtonPrimary InfoQuestionButton" (click)="this.parent.RedirectToURL('/dashboard/settings/mycompany');"> {{ 'Configuration.GoToSettings' | translate }}</button>
      </div>
    </div>

    <div class="InfoQuestion animated fadeInDown" *ngIf="ShowSubordronateDocumentsWarning">
      <div class="InfoQuestionClose">
        <i class="material-icons" (click)="ShowSubordronateDocumentsWarning = false;">close</i>
      </div>
      <div class="InfoQuestionTitle">
        {{ 'Attention' | translate }}
      </div>
      <div class="InfoQuestionBody">
        {{this.SubordronateDocumentsMessage}}

        <div class="SubordronateDetectedPairs">{{'DetectedPairs' | translate}}: <span style="color: #32aa3a;">{{SalesDocumentsPairsCOUNT}}</span></div>
      </div>

      <div class="InfoQuestionCommands SubordronateDocumentsContainerCommands">
        <button [disabled]="this.parent.loading" class="ModernButton ModernButtonPrimary SubordronateDocumentsCommandButton" (click)="AddInvoice(false, true);">
          <i class="material-icons">verified</i>
          {{ 'AddWithSubordonatePairs' | translate }}
        </button>
        <button [disabled]="this.parent.loading" class="ModernButton ModernButtonWarning SubordronateDocumentsCommandButton" (click)="AddInvoice(true, false);">
          <i class="material-icons">dnd_forwardslash</i>
          {{ 'ContinueWithout' | translate }}
        </button>
      </div>
    </div>

    <div class="animated fadeInDown SubordonateProductsAdjustmentContainer" *ngIf="ShowSubordonateProductsAdjustment">
      <div class="PopUpCloseContainer" (click)="ShowSubordonateProductsAdjustment = false;">
        <i class="material-icons">close</i>
      </div>

      <div class="PopUpTitleContainer">
        <p>{{ 'SubordonateSettings' | translate }}</p>
       </div>

       <div class="PopUpBody" style="margin-bottom: 0px;padding-top: 10px;">

        <div class="SubordonateProductAdjustmentRow" style="text-align: left;">
          <mat-slide-toggle matTooltip="{{ 'ProductSubordonateAutoAdjustSettingDesc' | translate }}" matTooltipClass='neutral-tool-tip' [(ngModel)]="ProductSubordonateAutoAdjust">{{'ProductSubordonateAutoAdjustSetting' | translate}}</mat-slide-toggle>
        </div>

        <div class="SubordonateProductAdjustmentRow" style="text-align: left;">
          <mat-slide-toggle matTooltip="{{ 'ProductSubordonateFillBacklogDifferenceSettingDesc' | translate }}" matTooltipClass='neutral-tool-tip' [(ngModel)]="ProductSubordonateFillBacklogDifference">{{'ProductSubordonateFillBacklogDifferenceSetting' | translate}}</mat-slide-toggle>
        </div>

        <div class="SubordonateProductAdjustmentRow" *ngFor="let p of this.NewProduct?.SubordonatesInfo?.Products">
          <div class="SubordonatesAdjustButton" (click)="p.ReservedAmmount = p.ReservedAmmount - 1;">-</div>
          <div class="SubordonatesAdjustButton" (click)="p.ReservedAmmount = p.ReservedAmmount + 1;">+</div>

          <div class="PopUpBodyRowContainer">
            <p class="NewTextBoxContainerTitle">{{p.Administration.Company.Name}}</p>
            <div class="NewTextBoxContainer" style="width: 100%;">
              <input type="number" class="NewTextBox" [(ngModel)]="p.ReservedAmmount">
            </div>
          </div>
        </div>
      </div>

       <div class="PopUpCommands">
        <button [disabled]="parent.loading" class="ModernButton ModernButtonAccent ProductsAdjustmentButton" matTooltip="" (click)="AutoAdjustProductSubordonateQuantities(this.ProductSubordonateAutoAdjust, true);">
          <i class="material-icons">check</i>
          {{ 'Apply' | translate }}
        </button>
        <button [disabled]="parent.loading" class="ModernButton ModernButtonPrimary ProductsAdjustmentButton" matTooltip="" (click)="AutoAdjustProductSubordonateQuantities(true);">
          <i class="material-icons">autorenew</i>
          {{ 'AutoAdjust' | translate }}
        </button>
      </div>
    </div>

    <div class="InfoQuestion animated fadeInDown" *ngIf="ShowProformaInvoiceConvertorQuestion">
      <div class="InfoQuestionClose">
        <i class="material-icons" (click)="ShowProformaInvoiceConvertorQuestion = false;">close</i>
      </div>
      <div class="InfoQuestionTitle">
        {{ 'ProformaInvoiceConversionTitle' | translate }} -  {{this.CurrentInvoice.AccountingNumber.DisplayValue}}
      </div>
      <div class="InfoQuestionBody">
        {{ 'ProformaInvoiceConversionQuestion' | translate }}
      </div>

      <div class="InfoQuestionCommands">
        <button [disabled]="this.parent.loading" class="ModernButton ModernButtonSecondary InfoQuestionButton" (click)="ShowProformaInvoiceConvertorQuestion = false;">
          {{ 'Configuration.DeleteNoButton' | translate }}
        </button>
        <button [disabled]="this.parent.loading" class="ModernButton ModernButtonAccent InfoQuestionButton ConvertToInvoiceFromProformaButton" (click)="ConvertProformaToInvoice(CurrentInvoice.ID);">
          <i class="material-icons">domain_verification</i>
          {{ 'ConvertToInvoice' | translate }}
        </button>
      </div>
    </div>

      <div class="animated fadeInDown DiscountContainer" *ngIf="showProductDiscountContainer">
        <div class="PopUpCloseContainer" (click)="showProductDiscountContainer = false;">
          <i class="material-icons">close</i>
        </div>

        <div class="PopUpTitleContainer">
          <p>{{ 'Receptions.MenuDiscount' | translate }}</p>
         </div>

         <div class="PopUpBody" style="margin-bottom: 0px;padding-top: 10px;">

          <div class="PopUpBodyRowContainer">
            <p class="NewTextBoxContainerTitle">{{ 'Receptions.DiscountType' | translate }}</p>
            <div class="NewTextBoxContainer" style="width: 100%;">
              <mat-select class="NewTextBox" name="discounts" [compareWith]="compareFn" [(ngModel)]="CurrentProduct.ProductInvoiceInfo.Price.Discount.Type">
                <mat-option *ngFor="let d of this.DiscountTypes" [value]="d" (onSelectionChange)="chanveNewProductVALUE($event);">
                  {{d.Name}}
                </mat-option>
              </mat-select>
            </div>
          </div>

          <div class="PopUpBodyRowContainer">
            <p class="NewTextBoxContainerTitle">{{ 'Receptions.DiscountValue' | translate }}</p>
            <div class="NewTextBoxContainer" style="width: 100%;">
              <input class="NewTextBox" type="text" autocomplete="off" [(ngModel)]="CurrentProduct.ProductInvoiceInfo.Price.Discount.Value" placeholder="{{ 'Receptions.DiscountValue' | translate }}">
            </div>
          </div>

        </div>

         <div class="PopUpCommands">
          <button (click)="ApplyDiscount();" [disabled]="parent.loading" class="ModernButton ModernButtonPrimary PopGeneralCommandButton" matTooltip="{{ 'Receptions.ApplyDiscount' | translate }}">{{ 'Receptions.ApplyDiscount' | translate }}</button>
        </div>
      </div>

      <div class="animated fadeInDown DiscountContainer" *ngIf="showDocumentDiscountContainer">
        <div class="PopUpCloseContainer" (click)="showDocumentDiscountContainer = false;">
          <i class="material-icons">close</i>
        </div>

        <div class="PopUpTitleContainer">
          <p>{{ 'Receptions.DocDiscount' | translate }}</p>
         </div>

         <div class="PopUpBody" style="margin-bottom: 0px;padding-top: 10px;">

          <div class="PopUpBodyRowContainer">
            <p class="NewTextBoxContainerTitle">{{ 'Receptions.DiscountType' | translate }}</p>
            <div class="NewTextBoxContainer" style="width: 100%;">
              <mat-select class="NewTextBox" name="discounts" [compareWith]="compareFn" [(ngModel)]="CurrentInvoice.Total.Discount.Type">
                <mat-option *ngFor="let d of this.DiscountTypes" [value]="d">
                  {{d.Name}}
                </mat-option>
              </mat-select>
            </div>
          </div>

          <div class="PopUpBodyRowContainer">
            <p class="NewTextBoxContainerTitle">{{ 'Receptions.DiscountValue' | translate }}</p>
            <div class="NewTextBoxContainer" style="width: 100%;">
              <input class="NewTextBox" type="text" autocomplete="off" [(ngModel)]="CurrentInvoice.Total.Discount.Value" placeholder="{{ 'Receptions.DiscountValue' | translate }}">
            </div>
          </div>

        </div>

         <div class="PopUpCommands">
          <button (click)="ApplyInvoiceDiscount();" [disabled]="parent.loading" class="ModernButton ModernButtonPrimary PopGeneralCommandButton" matTooltip="{{ 'Receptions.ApplyDiscount' | translate }}">{{ 'Receptions.ApplyDiscount' | translate }}</button>
        </div>
      </div>

      <div class="MainTitleBar" *ngIf="this.CurrentInvoice?.Details?.ForceDocumentClosing == true && this.CurrentInvoice?.DocumentStatus?.ID == 1;">
        <div class="TopValueBanner"  [ngClass]="{'CollectedStatusPopUp': this.CurrentInvoice.DocumentStatus.ID == 1}">
          <div>
            {{CurrentInvoice.DocumentStatus.Name}} {{'ForcedDocumentClose' | translate}} 
            <i class="material-icons TopValueBannerIcon">verified</i>
          </div>
        </div>
      </div>

      <div class="MainTitleBar" *ngIf="this.CurrentInvoice.Details?.CashCollectionRemainingValue != undefined && this.CurrentInvoice.ID?.length > 0;">
        <div *ngIf="this.CurrentInvoice.DocumentStatus.ID != 2;" class="TopValueBanner"  [ngClass]="{'CollectedStatusPopUp': this.CurrentInvoice.Details.CashCollectionRemainingValue == 0, 'OverduePopUp': this.CurrentInvoice.Details.CashCollectionRemainingValue != 0 && this.CurrentInvoice.DocumentStatus.ID == 5}">
         <div *ngIf="this.CurrentInvoice.Details.CashCollectionRemainingValue != 0">
          {{'RemainingToCashCollect' | translate}}: 
          <span class="TopValueBannerValue">{{this.CurrentInvoice.Details.CashCollectionRemainingValue}} {{currency.Name}}</span>
          <i class="material-icons TopValueBannerIcon">money_off_csred</i>
          <i *ngIf="this.CurrentInvoice.Details.CashCollectionRemainingValue == 0" class="material-icons TopValueBannerIcon">verified</i>
         </div>
         <div *ngIf="this.CurrentInvoice.Details.CashCollectionRemainingValue == 0">
          {{this.CurrentInvoice.DocumentStatus.Name}}
          <i class="material-icons TopValueBannerIcon">verified</i>
         </div>
        </div>

        <div *ngIf="this.CurrentInvoice.DocumentStatus.ID == 2;" class="TopValueBanner" style="background: #ffebcc;">
          {{'OverCollected' | translate}}
          <span class="TopValueBannerValue">{{this.CurrentInvoice.Details.CashCollectionRemainingValue}} {{currency.Name}}</span>
          <i class="material-icons TopValueBannerIcon" style="color: #f60;">verified</i>
        </div>
      </div>

      <div class="MainTitleBar" *ngIf="this.CurrentInvoice.ID?.length > 0;">

        <div class="TopValueBanner" style="background: #efdc75;opacity: 0.75;">
          <span style="color: #f60;">{{'ClosedDocumentModificationWarning' | translate}}</span>
          <i class="material-icons TopValueBannerIcon" style="color: #f60;">lightbulb</i>
        </div>
      </div>

      <div class="MainTitleBar" *ngIf="this.CurrentInvoice?.Details?.EFacturaDetails?.Status?.ID > 0;">

        <div class="TopValueBanner" style="background: #ddd;opacity: 0.75;">
          <span style="color: #000;">{{'LockedByEFactura' | translate}}</span>
          <i class="material-icons TopValueBannerIcon" style="color: #000;">lock_outline</i>
        </div>
      </div>

      <div class="MainTitleBar">
        <p class="SectionTitle" style="margin-top: 0%;border-bottom: solid 1px #ddd;" *ngIf="this.CurrentInvoice.ID == null;">
          <span *ngIf="!IsStorno;">{{ 'NewInvoice' | translate }}</span>
          <span *ngIf="IsStorno;">{{ 'NewStornoInvoice' | translate }}</span>
          <span class="DocumentMainCurrencyTopValue">{{currency.Name}}</span>
        </p>

        <p class="SectionTitle ProformaTitle" *ngIf="this.CurrentInvoice.DocType?.ID == 1;">
          <span>{{ 'Proforma' | translate }}</span>
        </p>

        <p class="SectionTitle AdvanceInvoiceTitle" *ngIf="this.CurrentInvoice.DocType?.ID == 2;">
          <span>{{ 'AdvanceInvoice' | translate }}</span>
        </p>

        <p class="SectionTitle" style="margin-top: 0%;border-bottom: solid 1px #ddd;" *ngIf="this.CurrentInvoice?.ID != null;">
          <span *ngIf="!IsStorno;">{{ 'ModifyInvoice' | translate }} </span>
          <span *ngIf="IsStorno;">{{ 'Receptions.ModifyStorno' | translate }} </span> 
          <span class="InvoiceDisplayValue">{{this.CurrentInvoice.AccountingNumber.DisplayValue}}</span>
          <span class="DocumentMainCurrencyTopValue">{{currency.Name}}</span>
          </p>
    </div>

    <div class="MainBody animated fadeIn">
        <div class="NewReceptionBodyRow">
            <div class="PartnerSearchContainer">
                <p class="NewTextBoxContainerTitle">{{ 'SearchClient' | translate }}*</p>

                <!-- Partner Search Bar (iOS-style) -->
                <div class="PartnerSearchBar">
                  <i class="material-icons search-icon" *ngIf="!this.searchTerm || this.searchTerm.length === 0">search</i>
                  <i class="material-icons clear-icon" *ngIf="this.searchTerm?.length > 0" (click)="this.searchTerm=''; this.Partners.length = 0;resultsLength = 0;">close</i>
                  <input
                    type="text"
                    class="PartnerSearchInput"
                    placeholder="Name/VAT"
                    autocomplete="off"
                    [(ngModel)]="this.searchTerm"
                    (focus)="InitializePartnersOnClick(this.searchTerm, this.countryID, true);"
                    (ngModelChange)="this.searchPartnerUpdate.next($event)"
                    (keydown.enter)="this.partner = Partners[0];resultsLength = 0;this.searchTerm='';AdjustLanguageOnPartnerSeleciton();AdjustCurrencyOnPartnerSeleciton();AdjustPaymentTermOnPartnerSelect(Partners[0].ID);TestDocumentValidity();"
                  />
                  <i class="material-icons person-add-icon" *ngIf="!this.searchTerm" (click)="showAddNewPartnerPopUp = true;initializeAddPartnerForm();">person_add</i>
                  <mat-spinner class="search-spinner" *ngIf="parent.loading" [diameter]="20"></mat-spinner>
                </div>

                <!-- Search Results Dropdown -->
                <div class="PartnerSearchResults" *ngIf="resultsLength > 0">
                  <div class="PartnerSearchResult" *ngFor="let p of Partners" (click)="this.partner = p;resultsLength = 0;this.searchTerm='';AdjustLanguageOnPartnerSeleciton();AdjustCurrencyOnPartnerSeleciton();AdjustPaymentTermOnPartnerSelect(p.ID);TestDocumentValidity();">
                    <div class="PartnerResultMain">
                      <span class="PartnerName">{{p.Name}}</span>
                      <span class="PartnerVAT" *ngIf="p.VAT?.length">{{p.VAT}}</span>
                    </div>
                  </div>
                </div>

                <!-- Selected Partner Display -->
                <div class="PartnerInfoContainer" *ngIf="partner != null">
                  <i class="material-icons PartnerInfoContainerEUVerified" matTooltip="EU Verified" *ngIf="partner.EUVATVerified">verified_user</i>
                  <p class="PartnerInfoTitle">{{partner.Name }}
                      <i *ngIf="partner.ID != null;" class="material-icons PartnerDeleteIcon" (click)="partner = null;TestDocumentValidity();">close</i>
                      <i *ngIf="partner.ID != null;" class="material-icons PartnerEditIcon" (click)="initializePartnerFormFromObject(partner);">edit</i>
                      <i *ngIf="partner.ID == null;" class="material-icons PartnerEditIcon" (click)="InsertPartnerFromCloud(partner);">cloud_download</i>
                  </p>
                  <span class="PartnerInfoSubTitle" *ngIf="partner.VAT?.length;">{{partner.VAT}} | </span>
                  <span class="PartnerInfoSubTitle" *ngIf="partner.COCRegNumber?.length;">{{partner.COCRegNumber}}</span>
                  <p class="PartnerInfoSubTitle">{{partner.BillingAddress.Country.ShortName}}, {{partner.BillingAddress.StateProvince}}, {{partner.BillingAddress.City}},| {{partner.BillingAddress.AddressLine}}</p>
                </div>
            </div>

            <div class="newReceptionInputContainer" style="width: 40%;">
                <p class="NewTextBoxContainerTitle">{{ 'Receptions.DocumentDate' | translate }}</p>
                <div class="NewTextBoxContainer" style="width: 100%;">
                    <input type="text" class="NewTextBox" [matDatepicker]="dp" [formControl]="DocumentDate" [(ngModel)]="CurrentInvoice.DocumentDate" (dateChange)="TestDocumentValidity();GetDateByPaymentTerm(CurrentInvoice.PaymentTerm);">
                    <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                    <mat-datepicker #dp></mat-datepicker>
                </div>

                <p class="NewTextBoxContainerTitle">{{ 'PaymentTerms' | translate }}</p>
                <div class="NewTextBoxContainer" style="width: 100%;">
                    <mat-select class="NewTextBox" name="Series" [compareWith]="compareFn" [(ngModel)]="CurrentInvoice.PaymentTerm">
                      <mat-option *ngFor="let term of this.PaymentTerms" [value]="term" (click)="GetDateByPaymentTerm(term);">
                        {{term.Name}}
                      </mat-option>
                    </mat-select>
                </div>

                <p class="NewTextBoxContainerTitle">{{ 'Receptions.DueDate' | translate }}</p>
                <div class="NewTextBoxContainer" style="width: 100%;">
                    <input type="text" class="NewTextBox" [matDatepicker]="dp1" [formControl]="PaymentDueDate" [(ngModel)]="CurrentInvoice.PaymentDueDate" (dateChange)="TestDocumentValidity();CurrentInvoice.PaymentTerm = null;">
                    <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
                    <mat-datepicker #dp1></mat-datepicker>
                </div>
            </div>

            <div class="newReceptionInputContainer" style="width: 15%;">
                <p class="NewTextBoxContainerTitle" *ngIf="CurrentInvoice.AccountingNumber?.ID == null;">{{ 'Receptions.Series' | translate }}</p>
                <div class="NewTextBoxContainer" style="width: 100%;" *ngIf="CurrentInvoice.AccountingNumber?.ID == null;">
                    <mat-select class="NewTextBox" name="Series" [compareWith]="compareFn" [(ngModel)]="CurrentInvoice.AccountingNumber.AccountingSeries">
                      <mat-option *ngFor="let series of this.AccountingSeries" [value]="series">
                        {{series.Series}} (nr.XXXX)
                      </mat-option>
                    </mat-select>
                </div>

                <p class="NewTextBoxContainerTitle" *ngIf="CurrentInvoice.AccountingNumber?.ID != null;">{{ 'Receptions.Series' | translate }}</p>
                <div class="NewTextBoxContainer" style="width: 100%;" *ngIf="CurrentInvoice.AccountingNumber?.ID != null;">
                    <input type="text" class="NewTextBox" placeholder="Series" autocomplete="off" [(ngModel)]="this.CurrentInvoice.AccountingNumber.DisplayValue" disabled="disabled">
                </div>

                <p class="NewTextBoxContainerTitle">{{ 'Receptions.Currency' | translate }}</p>
                <div class="NewTextBoxContainer" style="width: 100%;">
                    <mat-select class="NewTextBox" name="currency" [compareWith]="compareFn" [(ngModel)]="currency">
                      <mat-option *ngFor="let c of this.Currencies" [value]="c" (click)="GetCurrencyLiveExchange(c);">
                        {{c.Name}}
                      </mat-option>
                    </mat-select>
                </div>

                <div class="ReceptionSelectedCurrency" *ngIf="currency != null && currency.ExchangeRate > 0;">
                    <p class="NewTextBoxContainerTitle">{{ 'Receptions.ExchangeRate' | translate }}</p>
                    <div class="NewTextBoxContainer" style="width: 100%;">
                        <input type="text" class="NewTextBox" [(ngModel)]="currency.ExchangeRate" placeholder="Exchange">
                        <i style="border: none;" class="material-icons PartnerEditIcon">edit</i>
                    </div>
                </div>
            </div>

            <div class="newReceptionInputContainer" style="width: 15%;">
                <p class="NewTextBoxContainerTitle">{{ 'Receptions.DecimalPercision' | translate }}</p>
                <div class="NewTextBoxContainer" style="width: 100%;">
                    <mat-select class="NewTextBox" name="DocType" [compareWith]="compareFn" [(ngModel)]="InvoicePrecision">
                      <mat-option *ngFor="let p of this.DecimalPrecisions" [value]="p" (click)="AdjustProductsDecimalPrecisionPrice();">
                        {{p.Meaning}}
                      </mat-option>
                    </mat-select>
                </div>

                <p class="NewTextBoxContainerTitle">{{ 'Language' | translate }}</p>
                <div class="NewTextBoxContainer" style="width: 100%;">
                    <mat-select class="NewTextBox" name="Languages" [compareWith]="compareFn" [(ngModel)]="CurrentInvoice.Language">
                      <mat-option *ngFor="let lang of this.Languages" [value]="lang">
                        {{lang.Name}}
                      </mat-option>
                    </mat-select>
                </div>
            </div>
        </div>

        <div class="ReceptionProductsContainer">
            <div class="ReceptionProductsRow" style="padding-top: 10px;border: none;">
                <div class="ReceptionProductsCol" style="width: 15%;">
                    <div class="NewTextBoxContainer" style="width: 100%;" *ngIf="NewProduct?.ID == null;">
                        <mat-select class="NewTextBox" name="Administration" [compareWith]="compareFn" [(ngModel)]="NewProduct.ProductInvoiceInfo.Administration">
                          <mat-option *ngFor="let a of this.Administrations;" [value]="a" (onSelectionChange)="chanveNewProductVALUE($event);" (click)="SearchProductsInvoicingInformation(NewProduct.ProductInvoiceInfo.Name, a.ID, false);">
                            {{a.Name}}
                          </mat-option>
                        </mat-select>
                    </div>

                    <div class="NewTextBoxContainer" style="width: 100%;" *ngIf="NewProduct?.ID != null;">
                        <input type="text" class="NewTextBox" disabled="disabled" placeholder="{{ 'Receptions.Administration' | translate }}" autocomplete="off" [(ngModel)]="NewProduct.ProductInvoiceInfo.Administration.Name">
                    </div>
                </div>
                <div class="ReceptionProductsCol" style="width: 20%;text-align: left;">
                    <div class="NewTextBoxContainer" style="width: 100%;">
                        <input type="text" class="NewTextBox" (click)="this.productSearchTermUpdate.next($event); showhideSearches(false);" placeholder="{{ 'Receptions.Table.Name' | translate }}" autocomplete="off" [(ngModel)]="NewProduct.ProductInvoiceInfo.Name" (ngModelChange)="chanveNewProductVALUE($event); this.productSearchTermUpdate.next($event);" (keydown.enter)="SelectReceptionProductFromSearch(ProductsSearchResults[0]);">
                        <i class="material-icons" style="cursor: pointer; pointer-events: auto;" *ngIf="ProductsSearchResultsCOUNT == 0 && !loadingSearchProducts && NewProduct.ProductInvoiceInfo.Name.length == 0;">search</i>
                        <i class="material-icons" style="cursor: pointer; pointer-events: auto;" *ngIf="(ProductsSearchResultsCOUNT > 0 || NewProduct.ProductInvoiceInfo.Name.length > 0) && !loadingSearchProducts;" (click)="DestroySearchedProducts();">close</i>
                    </div>
                      <div class="SpinnerIconContainer" *ngIf="loadingSearchProducts">
                        <mat-spinner class="smallSpinner" [diameter]="25"></mat-spinner>
                      </div>
                      <div class="PartnerStockInfo" *ngIf="this.NewProduct?.SubordonatesInfo?.AvailableQuantity > 0;">
                        <p style="color: #f60;">
                          {{this.NewProduct?.SubordonatesInfo?.AvailableQuantity}} {{'PiecesInPartnerStock' | translate}}
                        </p>
                        <p *ngFor="let c of this.NewProduct?.SubordonatesInfo.Companies;" style="color: #32aa3a;">
                          {{c.Name}}
                        </p>
                        <button class="ModernButton ModernButtonPrimary SubordonateButton" (click)="OpenSubordonateProductsAdjustment();">
                          <i class="material-icons">settings_ethernet</i>
                        </button>
                      </div>
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                    <div class="NewTextBoxContainer" style="width: 100%;">
                        <input type="text" class="NewTextBox" placeholder="{{ 'Receptions.Table.Code' | translate }}" autocomplete="off" [(ngModel)]="NewProduct.ProductInvoiceInfo.Code" (ngModelChange)="chanveNewProductVALUE($event); this.productSearchTermUpdate.next($event);" matTooltip="{{NewProduct.ProductInvoiceInfo.Code}}" matTooltipClass='purchase-tool-tip'>
                    </div>
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                    <div class="NewTextBoxContainer" style="width: 100%;">
                        <mat-select class="NewTextBox" name="Administration" [compareWith]="compareFirst" [(ngModel)]="NewProduct.ProductInvoiceInfo.MeasuringUnit">
                          <mat-option *ngFor="let u of this.MeasuringUnits" [value]="u" (selectionChange)="chanveNewProductVALUE($event);">
                            {{u.Name}}
                          </mat-option>
                        </mat-select>
                    </div>
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                    <div class="NewTextBoxContainer" style="width: 100%;">
                        <input type="text" class="NewTextBox" placeholder="{{ 'Receptions.Table.Qty' | translate }}" autocomplete="off" [(ngModel)]="NewProduct.ProductInvoiceInfo.Quantity" (ngModelChange)="chanveNewProductVALUE($event);CheckAndGetProductSubordonates(NewProduct);">
                    </div>
                </div>
                <div class="ReceptionProductsCol" style="width: 15%;">
                    <div class="NewTextBoxContainer" style="width: 100%;" *ngIf="!NewProductPriceContainsVAT">
                        <input type="text" class="NewTextBox" placeholder="{{ 'Receptions.Table.Price' | translate }}" autocomplete="off" [(ngModel)]="NewProduct.ProductInvoiceInfo.Price.UIUnitPrice" (ngModelChange)="chanveNewProductVALUE($event);" (change)="VerifyPriceModel(NewProduct.ProductInvoiceInfo.Price.UIUnitPrice);">
                    </div>

                    <div class="NewTextBoxContainer" style="width: 100%;" *ngIf="NewProductPriceContainsVAT">
                        <input type="text" class="NewTextBox" placeholder="{{ 'Receptions.Table.Price' | translate }}" autocomplete="off" [(ngModel)]="NewProduct.ProductInvoiceInfo.Price.UIVATUnitPrice" (ngModelChange)="chanveNewProductVALUE($event);" (change)="VerifyPriceModel(NewProduct.ProductInvoiceInfo.Price.UIVATUnitPrice);">
                    </div>
                </div>
                <div class="ReceptionProductsCol" style="width: 12.5%;">
                    <div class="NewTextBoxContainer" style="width: 100%;">
                        <mat-select class="NewTextBox" name="vats" [compareWith]="compareFirst" [(ngModel)]="NewProduct.ProductInvoiceInfo.Price.VAT">
                          <mat-option *ngFor="let v of this.VATRates" [value]="v" (click)="chanveNewProductVALUE($event);">
                            {{v.Name}}
                          </mat-option>
                        </mat-select>
                    </div>
                </div>
                <div class="ReceptionProductsCol" style="width: 15%;">
                  <button [disabled]="!IsValidNewProduct" class="ModernButton ModernButtonPrimary ReceptionProductsAddButton" (click)="AddProductToInvoice();">
                    <i class="material-icons">add</i>
                    <span>{{ 'Receptions.Table.AddToReception' | translate }}</span>
                </button>
                </div>

                <div class="ProductsSearchResultsContainer" *ngIf="ProductsSearchResultsCOUNT > 0 && showSearch;">
                  <div class="ProductSearchResult" *ngFor="let p of ProductsSearchResults" (click)="SelectReceptionProductFromSearch(p);" [ngClass]="{'SearchResultPoolProductAlert': p.IsFromPool}">
                    <p class="ProductSearchResultTitle">{{p.Name}} 
                      <span *ngIf="p.DiscrepancyAmmount != null;" class="DiscrepancyAmmountSpan" [ngClass]="{'MinusDiscrepancyAmmount': p.DiscrepancyAmmount < 0, 'NormalDiscrepancyAmmount': p.DiscrepancyAmmount >= 0}">{{p.DiscrepancyAmmount}}
                        <span *ngIf="p.DiscrepancyAmmount < 0;"> {{'MissingStockValue' | translate}}</span>
                        <span *ngIf="p.DiscrepancyAmmount >= 0;"> {{'StockValue' | translate}}</span>
                      </span>
                    </p>
                    <p class="ProductSearchResultType">[{{p.Code}}] [{{p.GeneralType.Name}}] <span *ngIf="p.IsFromPool;">[{{'PoolProduct' | translate}}]</span></p>
                  </div>
                </div>

            </div>

            <div class="ReceptionProductsRow" style="border: none;">
              <div class="ReceptionProductsCol" style="width: 15%;margin-top: 5px;">

              </div>
              <div class="ReceptionProductsCol" style="width: 35%;text-align: left;">
                <mat-form-field appearance="outline" style="width: 100%;">
                  <mat-label>{{ 'Description' | translate }}</mat-label>
                  <textarea autocomplete="off" matInput
                            cdkTextareaAutosize
                            #autosize="cdkTextareaAutosize"
                            cdkAutosizeMinRows="1"
                            cdkAutosizeMaxRows="10"
                            [(ngModel)]="NewProduct.ProductInvoiceInfo.Description"></textarea>
                </mat-form-field>
              </div>
              <div class="ReceptionProductsCol">

              </div>
              <div class="ReceptionProductsCol">

              </div>
              <div class="ReceptionProductsCol" style="width: 5%;">

              </div>
              <div class="ReceptionProductsCol" style="width: 10%;">

              </div>
              <div class="ReceptionProductsCol" style="width: 30%;text-align: right;padding-right: 20px;">

              </div>
          </div>

            <div class="ReceptionProductsRow" style="height: 50px;border: none;">
                <div class="ReceptionProductsCol" style="width: 15%;margin-top: 5px;">
                    <mat-slide-toggle [(ngModel)]="NewProductPriceContainsVAT"(change)="priceContainsVATchanged($event);">{{ 'Receptions.Table.PriceContainsVAT' | translate }}</mat-slide-toggle>
                </div>
                <div class="ReceptionProductsCol" style="width: 15%;text-align: left;">
                  <div class="NewTextBoxContainer" style="width: 100%;" *ngIf="NewProduct.ID == null;">
                    <mat-select class="NewTextBox" name="vats" [compareWith]="compareFirst" [(ngModel)]="NewProduct.GeneralType">
                      <mat-option *ngFor="let t of this.ProductGeneralTypes" [value]="t" (onSelectionChange)="chanveNewProductVALUE($event);">
                        {{t.Name}}
                      </mat-option>
                    </mat-select>
                  </div>

                  <div class="NewTextBoxContainer" style="width: 100%;" *ngIf="NewProduct.ID != null;">
                    <input type="text" class="NewTextBox" disabled="disabled" placeholder="{{ 'HOME.ProductType' | translate }}" autocomplete="off" [(ngModel)]="NewProduct.GeneralType.Name">
                  </div>
                </div>
                <div class="ReceptionProductsCol" style="width: 5%;">

                </div>
                <div class="ReceptionProductsCol" style="width: 5%;">

                </div>
                <div class="ReceptionProductsCol">

                </div>
                <div class="ReceptionProductsCol">

                </div>
                <div class="ReceptionProductsCol" style="width: 10%;">

                </div>
                <div class="ReceptionProductsCol" style="width: 10%;">

                </div>
                <div class="ReceptionProductsCol" style="width: 15%;text-align: right;">
                  <button class="ModernButton"
                          *ngIf="CurrentInvoice?.ID && CurrentInvoice?.DocumentStatus?.ID != -1 && CurrentInvoice?.DocumentStatus?.ID != 1"
                          [ngClass]="{'ModernButtonDanger': hasInsuranceApplied(), 'ModernButtonSuccess': !hasInsuranceApplied()}"
                          (click)="toggleInsurance();">
                    <i class="material-icons" style="font-size: 16px; vertical-align: middle;">{{hasInsuranceApplied() ? 'remove_circle_outline' : 'add_circle_outline'}}</i>
                    {{ hasInsuranceApplied() ? ('RemoveInsurance' | translate) : ('AddInsurance' | translate) }}
                  </button>
                </div>
                <div class="ReceptionProductsCol" style="width: 15%;text-align: right;padding-right: 20px;">
                  <button class="ModernButton ModernButtonPrimary" (click)="PrepareInvoiceForExportStepZero();">
                    {{ 'CustomsExport' | translate }} 🛃📦
                  </button>
                </div>
            </div>

            <div class="ReceptionProductsHeadder ReceptionProductsRow" style="border: none;">
                <div class="ReceptionProductsCol">
                    {{ 'Receptions.Table.Nr' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 10%;">
                    {{ 'Receptions.Administration' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 20%;text-align: left;padding-left: 1%;">
                    {{ 'Receptions.Table.Name' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                    {{ 'Receptions.Table.Code' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                    {{ 'Receptions.Table.MU' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                    {{ 'Receptions.Table.Qty' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 15%;">
                    {{ 'Receptions.Table.Price' | translate }}  ({{currency?.Name}})
                </div>
                <div class="ReceptionProductsCol" style="width: 12.5%;">
                    {{ 'Receptions.Table.Total' | translate }} ({{currency?.Name}})
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                    {{ 'Receptions.Table.VAT' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                  
                </div>
            </div>

            <div [ngClass]="{'NewProductAlertColor': p.ID == null || p.ID == 0, 'PoolProductAlert': p.IsFromPool}" class="ReceptionProductsRow ReceptionProductsRowHover" *ngFor="let p of this.Products; let i=index;" (dblclick)="OpenReceptionEditProduct(p.ProductInvoiceInfo.UIID);CurrentIndexProduct = i;">
              <div class="ReceptionProductsCol">
                  <p>{{i + 1}}</p>
                  <i [ngClass]="{'purchaseInfoIconIncomplete': p.ProductInvoiceInfo.PurchaseInfo?.Status.ID === -1}" class="material-icons purchaseInfoIcon" *ngIf="p.ProductInvoiceInfo.PurchaseInfo?.UIText?.length > 0;" matTooltip="{{p.ProductInvoiceInfo.PurchaseInfo?.UIText}}" matTooltipClass='purchase-tool-tip'>info</i>
              </div>
              <div class="ReceptionProductsCol" style="width: 10%;">
                  <p>{{p.ProductInvoiceInfo.Administration.Name}}</p>
                  <p class="NewProductAlert" *ngIf="p.ID == null || p.ID == 0;">[{{'NewProduct' | translate}}]</p>
                  <p class="PoolProductAlertRow" *ngIf="p.IsFromPool;">[{{'PoolProduct' | translate}}]</p>
              </div>
              <div class="ReceptionProductsCol" style="width: 20%;text-align: left;padding-left: 1%;">
                <p class="ProductNameRow">{{p.ProductInvoiceInfo.Name}}</p>
                <p class="ProductsDescriptionRow" *ngFor="let row of p.ProductInvoiceInfo.DescriptionRows; let j=index;">
                    {{row}}
                </p>
              </div>
              <div class="ReceptionProductsCol" style="width: 7.5%;">
                <p>{{p.ProductInvoiceInfo.Code}}</p>
                <p class="ReceptionProductsColDesc">{{p.ProductInvoiceInfo.GeneralType.Name}}</p>
              </div>
              <div class="ReceptionProductsCol" style="width: 7.5%;">
                {{p.ProductInvoiceInfo.MeasuringUnit.Name}}
              </div>
              <div class="ReceptionProductsCol" style="width: 7.5%;">
                {{p.ProductInvoiceInfo.Quantity}}
                <p class="SubordonateExtractInfoRow" *ngIf="p.SubordonatesInfo?.TotalReservedQuantity > 0;">{{'FromPartners' | translate}}: {{p.SubordonatesInfo.TotalReservedQuantity}}</p>
                <div class="AdvancePaymentRow" *ngIf="this.CurrentInvoice.AdvancePaymentPercentage != null && this.CurrentInvoice.DocType.ID == 2;">
                  <span *ngIf="p.ProductInvoiceInfo.Price.UIUnitPriceAdvance != null;">{{'Advance' | translate}} ({{this.CurrentInvoice.AdvancePaymentPercentage}}%):</span>
                </div>
              </div>
              <div class="ReceptionProductsCol" style="width: 15%;">
                <span *ngIf="p.ProductInvoiceInfo.Price.Discount == null || p.ProductInvoiceInfo.Price.Discount.Value == null">{{p.ProductInvoiceInfo.Price.UIUnitPrice}}</span>
                <span *ngIf="p.ProductInvoiceInfo.Price.Discount != null && p.ProductInvoiceInfo.Price.Discount.Value != null">{{p.ProductInvoiceInfo.Price.UIUnitPriceDiscount}}</span>

                <div class="AdvancePaymentRow" *ngIf="this.CurrentInvoice.AdvancePaymentPercentage != null && this.CurrentInvoice.DocType.ID == 2;">
                  <span *ngIf="p.ProductInvoiceInfo.Price.UIUnitPriceAdvance != null;">{{p.ProductInvoiceInfo.Price.UIUnitPriceAdvance}}</span>
                </div>
              </div>
              <div class="ReceptionProductsCol" style="width: 12.5%;">
                <span *ngIf="p.ProductInvoiceInfo.Price.Discount == null || p.ProductInvoiceInfo.Price.Discount.Value == null">{{p.ProductInvoiceInfo.Price.UIQtyPrice}}</span>
                <span *ngIf="p.ProductInvoiceInfo.Price.Discount != null && p.ProductInvoiceInfo.Price.Discount.Value != null">{{p.ProductInvoiceInfo.Price.UIQtyPriceDiscount}}</span>

                <div class="AdvancePaymentRow" *ngIf="this.CurrentInvoice.AdvancePaymentPercentage != null && this.CurrentInvoice.DocType.ID == 2;">
                  <span *ngIf="p.ProductInvoiceInfo.Price.UIQtyPriceAdvance != null;">{{p.ProductInvoiceInfo.Price.UIQtyPriceAdvance}}</span>
                </div>
              </div>
              <div class="ReceptionProductsCol" style="width: 7.5%;">
                <span>{{p.ProductInvoiceInfo.Price.TotalVATValue}}</span>

                <div class="AdvancePaymentRow" *ngIf="this.CurrentInvoice.AdvancePaymentPercentage != null && this.CurrentInvoice.DocType.ID == 2;">
                  <span *ngIf="p.ProductInvoiceInfo.Price.TotalVATValueAdvance != null;">{{p.ProductInvoiceInfo.Price.TotalVATValueAdvance}}</span>
                </div>
              </div>
              <div class="ReceptionProductsCol" style="width: 7.5%;">
                <i class="material-icons ReceptionProductEdit" (click)="OpenReceptionEditProduct(p.ProductInvoiceInfo.UIID);CurrentIndexProduct = i;">edit</i>
                <div class="ReceptionProductEdit" (click)="OpenProductDiscountContainer(p);CurrentIndexProduct = i;" *ngIf="CurrentInvoice.Total.Discount != undefined && CurrentInvoice.Total.Discount.Value == null;">%</div>
                <i class="material-icons ReceptionProductEdit" style="color: red;" (click)="DeleteAuxProduct(p.ProductInvoiceInfo.UIID);TestDocumentValidity();">close</i>
              </div>
              
              <div style="margin-left: 0%;margin-right: unset;float: left;background: #ddf4b9;cursor: pointer;" class="ProductDiscountRow" *ngIf="p.ProductInvoiceInfo.GeneralType.ID != 1 && p.ProductInvoiceInfo.GeneralType.IsTaxConsumed == true;" (click)="OpenProductTaxDivision(p.ProductInvoiceInfo.UIID);">
                <p>
                  {{ 'Receptions.Consumed' | translate }}
                </p>
                <p>
                  ({{p.ProductInvoiceInfo.GeneralType.TaxDivisionType.Name}})
                </p>
              </div>

              <div class="ProductDiscountRow" *ngIf="p.ProductInvoiceInfo.Price.Discount != null && p.ProductInvoiceInfo.Price.Discount.Value != null">
                  <p>
                    Discount - {{p.ProductInvoiceInfo.Price.Discount.Value}}
                    <span *ngIf="p.ProductInvoiceInfo.Price.Discount.Type.ID == 1;">%</span>
                    <span *ngIf="p.ProductInvoiceInfo.Price.Discount.Type.ID == 2;">{{currency.Name}}</span>
                  </p>
              </div>

          </div>

          <div class="ReceptionProductsRow ReceptionProductsRowHover TotalRow" *ngIf="this.Products.length;">
            <div class="ReceptionProductsCol">
               
            </div>
            <div class="ReceptionProductsCol" style="width: 10%;">
                
            </div>
            <div class="ReceptionProductsCol" style="width: 20%;text-align: left;padding-left: 1%;">
              
            </div>
            <div class="ReceptionProductsCol" style="width: 7.5%;">
              
            </div>
            <div class="ReceptionProductsCol" style="width: 7.5%;">
             
            </div>
            <div class="ReceptionProductsCol" style="width: 7.5%;">
              
            </div>
            <div class="ReceptionProductsCol" style="width: 15%;">
              Total:
            </div>
            <div class="ReceptionProductsCol" style="width: 12.5%;">
              {{this.CurrentInvoice.Total.TotalQtyPriceNOVAT}}
              <p *ngIf="CurrentInvoice.PurchaseStatus?.ID == 1;">
                <!-- <i class="material-icons purchaseInfoIcon" matTooltip="{{'PurchasePrice' | translate}}: {{CurrentInvoice.Total.UITotalPurchaseCost.Integer}}{{CurrentInvoice.Total.UITotalPurchaseCost.Decimals}} {{this.CurrentInvoice.Currency.Name}}" matTooltipClass='purchase-tool-tip'>info</i> -->
                <i class="material-icons purchaseInfoIcon" matTooltip="{{this.CurrentInvoice.Total.TotalPurchaseInfoUIText}}" matTooltipClass='purchase-tool-tip'>info</i>
              </p>
            </div>
            <div class="ReceptionProductsCol" style="width: 7.5%;">
              {{this.CurrentInvoice.Total.TotalVAT}}
            </div>
            <div class="ReceptionProductsCol" style="width: 7.5%;">
              {{this.CurrentInvoice.Total.TotalQtyPriceVAT}}
            </div>
        </div>

        <div class="ReceptionProductsRow ReceptionProductsRowHover TotalRow" *ngIf="this.Products.length && this.CurrentInvoice.AdvancePaymentPercentage != null && this.CurrentInvoice.DocType.ID == 2;">
          <div class="ReceptionProductsCol">
             
          </div>
          <div class="ReceptionProductsCol" style="width: 10%;">
              
          </div>
          <div class="ReceptionProductsCol" style="width: 20%;text-align: left;padding-left: 1%;">
            
          </div>
          <div class="ReceptionProductsCol" style="width: 7.5%;">
            
          </div>
          <div class="ReceptionProductsCol" style="width: 7.5%;">
           
          </div>
          <div class="ReceptionProductsCol" style="width: 7.5%;">
            
          </div>
          <div class="ReceptionProductsCol" style="width: 15%;">
            <div class="AdvancePaymentRow">
              Total {{'Advance' | translate}} ({{this.CurrentInvoice.AdvancePaymentPercentage}}%):
            </div>
          </div>
          <div class="ReceptionProductsCol" style="width: 12.5%;">
            <div class="AdvancePaymentRow">
              {{this.CurrentInvoice.TotalAdvance.TotalQtyPriceNOVAT}}
            </div>
          </div>
          <div class="ReceptionProductsCol" style="width: 7.5%;">
            <div class="AdvancePaymentRow">
              {{this.CurrentInvoice.TotalAdvance.TotalVAT}}
            </div>
          </div>
          <div class="ReceptionProductsCol" style="width: 7.5%;">
            <div class="AdvancePaymentRow">
              {{this.CurrentInvoice.TotalAdvance.TotalQtyPriceVAT}}
            </div>
          </div>
      </div>

        <div class="ReceptionProductsRow ReceptionProductsRowHover TotalRow" *ngIf="this.Products.length;">
          <div class="ReceptionProductsCol" style="width: 15%;">
            <button mat-button color="warn" (click)="EliminateDocumentDiscount();" *ngIf="CurrentInvoice.Total.Discount != null && CurrentInvoice.Total.Discount.Value != null">
              <i class="material-icons buttonIcon">close</i>
              {{ 'Receptions.EliminateDiscount' | translate }}
             </button>
          </div>
          <div class="ReceptionProductsCol" style="width: 20%;text-align: left;padding-left: 1%;">
            
          </div>
          <div class="ReceptionProductsCol" style="width: 7.5%;">
            
          </div>
          <div class="ReceptionProductsCol" style="width: 15%;">
            
          </div>
          <div class="ReceptionProductsCol" style="width: 15%;">
            <div class="ProductGeneralDiscountRow" *ngIf="CurrentInvoice.Total.Discount != null && CurrentInvoice.Total.Discount.Value != null">
              <p style="padding-top: 0px;line-height: 35px;overflow: hidden;">
                Discount - {{CurrentInvoice.Total.Discount.Value}}
                <span *ngIf="CurrentInvoice.Total.Discount.Type.ID == 1;">%</span>
                <span *ngIf="CurrentInvoice.Total.Discount.Type.ID == 2;">{{currency.Name}}</span>
              </p>
          </div>
          </div>
          <div class="ReceptionProductsCol" style="width: 27.5%;text-align: right;padding-right: 10px;">
            <button mat-button color="primary" (click)="OpenDocumentDiscountContainer();">{{ 'Receptions.DocDiscount' | translate }} %</button>
          </div>
      </div>
        </div>
        <div class="ReceptionBottomCommands">

          <div class="BottomCommandsOverlay" *ngIf="!ValidDocument;"></div>

          <div class="PopUpBodyRowContainer" *ngIf="CurrentInvoice?.DocType?.ID == 2;">
            <div class="PopUpBodyOneThirddContainer">
              <p class="NewTextBoxContainerTitle">{{ 'AdvancePaymentPercentage' | translate }}</p>
              <div class="NewTextBoxContainer" style="width: 100%;">
                <input type="text" class="NewTextBox" placeholder="{{ 'AdvancePaymentPercentage' | translate }}" autocomplete="off" [(ngModel)]="this.CurrentInvoice.AdvancePaymentPercentage" (change)="ImplementAdvancePaymentValues();">
              </div>
            </div>
          </div>

          <div class="PopUpBodyRowContainer">
            <div class="PopUpBodyOneThirddContainer" style="padding-left: 10px;">
              <div class="PopUpBodyRowContainer">
                <mat-checkbox [(ngModel)]="CurrentInvoice.Details.StockDischarging">{{ 'DischargeStocks' | translate }}</mat-checkbox>
              </div>
              <div class="PopUpBodyRowContainer">
                <mat-checkbox [(ngModel)]="CurrentInvoice.Details.IsSignedByAgent">{{ 'IsSignedByAgent' | translate }}</mat-checkbox>
              </div>
            </div>
            <div class="PopUpBodyOneThirddContainer">
               <div class="PopUpBodyRowContainer animated fadeIn" *ngIf="CurrentInvoice.Details.Agent != null && CurrentInvoice.Details.Agent.ID != null && CurrentInvoice.Details.IsSignedByAgent && this.Products.length > 0;">
                <img [src]="this.parent.BackendServiceUrl + this.CurrentInvoice.Details.Agent?.Signature" class="signatureImage" />
              </div>
            </div>
            <div class="PopUpBodyOneThirddContainer">
              <mat-form-field appearance="outline" style="width: 100%;">
                <mat-label>{{ 'SignStampSubstitute' | translate }}</mat-label>
                <textarea autocomplete="off" matInput
                          cdkTextareaAutosize
                          #autosize="cdkTextareaAutosize"
                          cdkAutosizeMinRows="5"
                          cdkAutosizeMaxRows="5"
                          [(ngModel)]="CurrentInvoice.Details.SignStampSubstitute" disabled="disabled"></textarea>
              </mat-form-field>
            </div>
          </div>

            <div class="PopUpBodyRowContainer" style="margin-top: 30px;">
              <div class="PopUpBodyOneThirddContainer">

                <div class="PopUpBodyRowContainer">
                  <p class="NewTextBoxContainerTitle">{{ 'InvoiceCreatingAgent' | translate }}</p>
                  <div class="NewTextBoxContainer" style="width: 100%;">
                    <mat-select class="NewTextBox" [(ngModel)]="CurrentInvoice.Details.Agent" name="Agent" [compareWith]="compareFn">
                      <mat-option *ngFor="let a of this.Agents" [value]="a">
                        {{a.Name}}
                      </mat-option>
                    </mat-select>
                  </div>
                </div>

                <mat-form-field appearance="outline" style="width: 100%;">
                  <mat-label>{{ 'IDCARD' | translate }}/{{ 'PersonalIDNumber' | translate }}</mat-label>
                  <textarea matInput cdkTextareaAutosize [(ngModel)]="CurrentInvoice.Details.IDCard"></textarea>
                </mat-form-field>

                <mat-form-field appearance="outline" style="width: 100%;">
                  <mat-label>{{ 'WayBill' | translate }}</mat-label>
                  <textarea matInput cdkTextareaAutosize [(ngModel)]="CurrentInvoice.Details.WayBillID"></textarea>
                </mat-form-field>
              </div>

              <div class="PopUpBodyOneThirddContainer">
                <mat-form-field appearance="outline" style="width: 100%;">
                  <mat-label>{{ 'Receptions.Delegate' | translate }}</mat-label>
                  <textarea matInput cdkTextareaAutosize [(ngModel)]="CurrentInvoice.Details.Delegate"></textarea>
                </mat-form-field>

                <mat-form-field appearance="outline" style="width: 100%;">
                  <mat-label>{{ 'Receptions.Auto' | translate }}</mat-label>
                  <textarea matInput cdkTextareaAutosize [(ngModel)]="CurrentInvoice.Details.Auto"></textarea>
                </mat-form-field>
              </div>

              <div class="PopUpBodyOneThirddContainer">
                <mat-form-field appearance="outline" style="width: 100%;">
                  <mat-label>{{ 'Receptions.Mentions' | translate }}</mat-label>
                  <textarea autocomplete="off" matInput
                            cdkTextareaAutosize
                            #autosize="cdkTextareaAutosize"
                            cdkAutosizeMinRows="1"
                            cdkAutosizeMaxRows="10"
                            [(ngModel)]="CurrentInvoice.Details.Observations"></textarea>
                </mat-form-field>

                <mat-form-field appearance="outline" style="width: 100%;">
                  <mat-label>{{ 'Receptions.InternalCommentary' | translate }}</mat-label>
                  <textarea autocomplete="off" matInput
                            cdkTextareaAutosize
                            #autosize="cdkTextareaAutosize"
                            cdkAutosizeMinRows="1"
                            cdkAutosizeMaxRows="10"
                            [(ngModel)]="CurrentInvoice.Details.InternalCommentary"></textarea>
                </mat-form-field>

                <div class="PopUpBodyRowContainer" style="margin-top: 5px;">
                   <button class="ModernButton ModernButtonSecondary" style="float:right;" (click)="TrackInvoice(this.CurrentInvoice);">
                    <i class="material-icons">near_me</i>
                    {{'Track' | translate}}
                   </button>

                    <button class="ModernButton ModernButtonSecondary" style="float:right;margin-right: 10px;" (click)="GetShippingDetails(this.CurrentInvoice.Details.ID, this.CurrentInvoice.Client.ID);">
                      <i class="material-icons">local_shipping</i>
                      {{'ShippingDetails' | translate}}
                    </button>
                </div>

                <div class="PopUpBodyRowContainer" style="margin-top: 5px;">
                  <mat-slide-toggle [(ngModel)]="this.CurrentInvoice.Details.ForceDocumentClosing" style="margin-top: 14px;" matTooltip="{{'ForceDocumentClosingDesc' | translate}}" matTooltipClass='neutral-tool-tip'>{{'ForceDocumentClosing' | translate}}</mat-slide-toggle>
                </div>
              </div>
            </div>

            <div class="PopUpBodyRowContainer" *ngIf="CurrentInvoice.DocType.ID == 0 && CurrentInvoice?.Details?.EFacturaDetails?.Status.ID <= 0;">
              <button class="ModernButton ModernButtonPrimary SaveReceptionButton" *ngIf="CurrentInvoice.ID == null;" (click)="AddInvoice();">
                 <span *ngIf="!IsStorno;">{{ 'SaveInvoice' | translate }}</span>
                 <span *ngIf="IsStorno;">{{ 'SaveStornoInvoice' | translate }}</span>
                 <i class="material-icons">save_alt</i>
              </button>

              <button class="ModernButton ModernButtonPrimary SaveReceptionButton" *ngIf="CurrentInvoice.ID != null;" (click)="UpdateInvoice();">
                <span *ngIf="!IsStorno;">{{ 'UpdateInvoice' | translate }}</span>
                <span *ngIf="IsStorno;">{{ 'UpdateStornoInvoice' | translate }}</span>
                <i class="material-icons">save_alt</i>
             </button>
            </div>

            <div class="PopUpBodyRowContainer" *ngIf="CurrentInvoice.DocType.ID == 1 && CurrentInvoice?.Details?.EFacturaDetails?.Status?.ID <= 0;">
              <button class="ModernButton ModernButtonPrimary SaveReceptionButton" *ngIf="CurrentInvoice.ID == null;" (click)="AddInvoice();">
                 <span>{{ 'SaveProformaInvoice' | translate }}</span>
                 <i class="material-icons">save_alt</i>
              </button>

              <button class="ModernButton ModernButtonPrimary SaveReceptionButton" *ngIf="CurrentInvoice.ID != null;" (click)="UpdateInvoice();">
                <span>{{ 'UpdateProformaInvoice' | translate }}</span>
                <i class="material-icons">save_alt</i>
             </button>

             <div class="PopUpBodyRowContainer" style="margin-top: 20px;">
              <button class="ModernButton ModernButtonSuccess SaveReceptionButton" *ngIf="CurrentInvoice.ID != null;" (click)="ConvertProformaToInvoiceQuestion(CurrentInvoice);">
                <span>{{ 'ConvertToInvoice' | translate }}</span>
                <i class="material-icons">save_alt</i>
              </button>
             </div>

            </div>

            <div class="PopUpBodyRowContainer" *ngIf="CurrentInvoice.DocType.ID == 2 && CurrentInvoice?.Details?.EFacturaDetails?.Status?.ID <= 0;">
              <button class="ModernButton ModernButtonPrimary SaveReceptionButton" *ngIf="CurrentInvoice.ID == null;" (click)="AddInvoice();">
                 <span>{{ 'SaveAdvanceInvoice' | translate }}</span>
                 <i class="material-icons">save_alt</i>
              </button>

              <button class="ModernButton ModernButtonPrimary SaveReceptionButton" *ngIf="CurrentInvoice.ID != null;" (click)="UpdateInvoice();">
                <span>{{ 'UpdateAdvanceInvoice' | translate }}</span>
                <i class="material-icons">save_alt</i>
             </button>
            </div>

            <div class="PopUpBodyRowContainer" *ngIf="CurrentInvoice?.Details?.EFacturaDetails?.Status?.ID > 0;">
              <button class="ModernButton ModernButtonPrimary SaveReceptionButton" disabled="true">
                 <span>{{ 'LockedByEFactura' | translate }}</span>
                 <i class="material-icons">lock_outline</i>
              </button>
            </div>

            <div class="PopUpBodyRowContainer" *ngIf="CurrentInvoice?.Details?.EFacturaDetails?.Status?.ID > 0;" style="margin-top: 20px;">
              <button class="ModernButton ModernButtonPrimary SaveReceptionButton" (click)="UpdateInvoiceDetails();">
                <span>{{ 'InvoiceOnlyDetailsUpdateBecauseEFacturaLock' | translate }}</span>
                <i class="material-icons">sync_lock</i>
             </button>
            </div>
          </div>
    </div>
</div>

<!-- Shipping Details Overlay - Outside MainContainer for full viewport coverage -->
<div class="overlay" *ngIf="ShowShippingDetailsContainer"></div>

<!-- Shipping Details Container - Outside MainContainer for proper fixed positioning -->
<div class="ShippingDetailsContainer animated fadeInDown" *ngIf="ShowShippingDetailsContainer == true;">
  <div class="ShippingDetailsContainerCloseIcon">
    <i class="material-icons" (click)="ShowShippingDetailsContainer = false;">close</i>
  </div>

  <div class="ShippingDetailsContainerTitle">{{'ShippingDetails' | translate}}</div>

  <div class="ShippingDetailsContainerBody">

    <!-- General Shipping Info Section Header -->
    <div class="ModernFormSectionHeader AppleSectionHeader" (click)="shippingGeneralInfoCollapsed = !shippingGeneralInfoCollapsed">
      <div class="AppleSectionHeaderLeft">
        <i class="material-icons AppleSectionIcon">local_shipping</i>
        <span class="AppleSectionTitle">{{'GeneralShippingInformation' | translate}}</span>
        <img *ngIf="this.CurrentInvoice.Details.ShippingDetails?.ShippingCompany?.ImagePath?.length > 0;" [src]="this.parent.BackendServiceUrl + this.CurrentInvoice.Details.ShippingDetails.ShippingCompany.ImagePath" class="ShippingDetailsContainerShippingCompanyImage" style="height: 20px; margin-left: 8px;" />
      </div>
      <i class="material-icons AppleSectionChevron" [class.collapsed]="shippingGeneralInfoCollapsed">expand_more</i>
    </div>

    <!-- Shipping Form Grid - Custom Dropdown Design -->
    <div class="AppleSectionContent" *ngIf="!shippingGeneralInfoCollapsed">
      <!-- Shipping Service Type Dropdown -->
      <div class="CustomDropdownContainer">
        <div class="SendEmailOverlayTransparent" *ngIf="showShippingServiceTypeDropdown" (click)="showShippingServiceTypeDropdown = false"></div>
        <div class="CustomDropdownBar" (click)="showShippingServiceTypeDropdown = !showShippingServiceTypeDropdown">
          <span class="dropdown-label">{{ 'ShippingServiceType' | translate }}</span>
          <i class="material-icons dropdown-icon-left">speed</i>
          <i class="material-icons send-email-icon" [style.color]="this.CurrentInvoice.Details.ShippingDetails?.ShippingServiceType?.ID ? '#4caf50' : '#f44336'">
            {{ this.CurrentInvoice.Details.ShippingDetails?.ShippingServiceType?.ID ? 'check_circle' : 'cancel' }}
          </i>
          <input type="text" class="CustomDropdownInput" [class.placeholder]="!this.CurrentInvoice.Details.ShippingDetails?.ShippingServiceType" [value]="this.CurrentInvoice.Details.ShippingDetails?.ShippingServiceType?.Name || ''" readonly />
          <i class="material-icons dropdown-icon">arrow_drop_down</i>
        </div>
        <div class="CustomDropdownResults" *ngIf="showShippingServiceTypeDropdown">
          <div class="CustomDropdownResult" *ngFor="let s of this.ShippingServiceTypes" (click)="this.CurrentInvoice.Details.ShippingDetails.ShippingServiceType = s; showShippingServiceTypeDropdown = false;">
            <div class="CustomDropdownResultMain">
              <i class="material-icons" [style.color]="this.CurrentInvoice.Details.ShippingDetails?.ShippingServiceType?.ID === s.ID ? '#4caf50' : '#ccc'">
                {{ this.CurrentInvoice.Details.ShippingDetails?.ShippingServiceType?.ID === s.ID ? 'check_circle' : 'radio_button_unchecked' }}
              </i>
              <span class="CustomDropdownResultText">{{s.Name}}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Shipping Way Dropdown -->
      <div class="CustomDropdownContainer">
        <div class="SendEmailOverlayTransparent" *ngIf="showShippingWayDropdown" (click)="showShippingWayDropdown = false"></div>
        <div class="CustomDropdownBar" (click)="showShippingWayDropdown = !showShippingWayDropdown">
          <span class="dropdown-label">{{ 'ShippingWay' | translate }}</span>
          <i class="material-icons dropdown-icon-left">route</i>
          <i class="material-icons send-email-icon" [style.color]="this.CurrentInvoice.Details.ShippingDetails?.ShippingWay?.ID ? '#4caf50' : '#f44336'">
            {{ this.CurrentInvoice.Details.ShippingDetails?.ShippingWay?.ID ? 'check_circle' : 'cancel' }}
          </i>
          <input type="text" class="CustomDropdownInput" [class.placeholder]="!this.CurrentInvoice.Details.ShippingDetails?.ShippingWay" [value]="this.CurrentInvoice.Details.ShippingDetails?.ShippingWay?.Name || ''" readonly />
          <i class="material-icons dropdown-icon">arrow_drop_down</i>
        </div>
        <div class="CustomDropdownResults" *ngIf="showShippingWayDropdown">
          <div class="CustomDropdownResult" *ngFor="let s of this.ShippingWays" (click)="this.CurrentInvoice.Details.ShippingDetails.ShippingWay = s; showShippingWayDropdown = false;">
            <div class="CustomDropdownResultMain">
              <i class="material-icons" [style.color]="this.CurrentInvoice.Details.ShippingDetails?.ShippingWay?.ID === s.ID ? '#4caf50' : '#ccc'">
                {{ this.CurrentInvoice.Details.ShippingDetails?.ShippingWay?.ID === s.ID ? 'check_circle' : 'radio_button_unchecked' }}
              </i>
              <span class="CustomDropdownResultText">{{s.Name}}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Shipping Responsability Dropdown -->
      <div class="CustomDropdownContainer">
        <div class="SendEmailOverlayTransparent" *ngIf="showShippingResponsabilityDropdown" (click)="showShippingResponsabilityDropdown = false"></div>
        <div class="CustomDropdownBar" (click)="showShippingResponsabilityDropdown = !showShippingResponsabilityDropdown">
          <span class="dropdown-label">{{ 'ShippingResponsability' | translate }}</span>
          <i class="material-icons dropdown-icon-left">assignment_ind</i>
          <i class="material-icons send-email-icon" [style.color]="this.CurrentInvoice.Details.ShippingDetails?.ShippingResponsability?.ID ? '#4caf50' : '#f44336'">
            {{ this.CurrentInvoice.Details.ShippingDetails?.ShippingResponsability?.ID ? 'check_circle' : 'cancel' }}
          </i>
          <input type="text" class="CustomDropdownInput" [class.placeholder]="!this.CurrentInvoice.Details.ShippingDetails?.ShippingResponsability" [value]="this.CurrentInvoice.Details.ShippingDetails?.ShippingResponsability?.Name || ''" readonly />
          <i class="material-icons dropdown-icon">arrow_drop_down</i>
        </div>
        <div class="CustomDropdownResults" *ngIf="showShippingResponsabilityDropdown">
          <div class="CustomDropdownResult" *ngFor="let s of this.ShippingResponsabilities" (click)="this.CurrentInvoice.Details.ShippingDetails.ShippingResponsability = s; showShippingResponsabilityDropdown = false;">
            <div class="CustomDropdownResultMain">
              <i class="material-icons" [style.color]="this.CurrentInvoice.Details.ShippingDetails?.ShippingResponsability?.ID === s.ID ? '#4caf50' : '#ccc'">
                {{ this.CurrentInvoice.Details.ShippingDetails?.ShippingResponsability?.ID === s.ID ? 'check_circle' : 'radio_button_unchecked' }}
              </i>
              <span class="CustomDropdownResultText">{{s.Name}}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Shipping Company Dropdown -->
      <div class="CustomDropdownContainer">
        <div class="SendEmailOverlayTransparent" *ngIf="showShippingCompanyDropdown" (click)="showShippingCompanyDropdown = false"></div>
        <div class="CustomDropdownBar" (click)="showShippingCompanyDropdown = !showShippingCompanyDropdown">
          <span class="dropdown-label">{{ 'ShippingCompany' | translate }}</span>
          <i class="material-icons dropdown-icon-left">business</i>
          <i class="material-icons send-email-icon" [style.color]="this.CurrentInvoice.Details.ShippingDetails?.ShippingCompany?.ID ? '#4caf50' : '#f44336'">
            {{ this.CurrentInvoice.Details.ShippingDetails?.ShippingCompany?.ID ? 'check_circle' : 'cancel' }}
          </i>
          <input type="text" class="CustomDropdownInput" [class.placeholder]="!this.CurrentInvoice.Details.ShippingDetails?.ShippingCompany" [value]="this.CurrentInvoice.Details.ShippingDetails?.ShippingCompany?.Name || ''" readonly />
          <i class="material-icons dropdown-icon">arrow_drop_down</i>
        </div>
        <div class="CustomDropdownResults" *ngIf="showShippingCompanyDropdown">
          <div class="CustomDropdownResult" *ngFor="let s of this.ShippingCompanies" (click)="this.CurrentInvoice.Details.ShippingDetails.ShippingCompany = s; showShippingCompanyDropdown = false;">
            <div class="CustomDropdownResultMain">
              <i class="material-icons" [style.color]="this.CurrentInvoice.Details.ShippingDetails?.ShippingCompany?.ID === s.ID ? '#4caf50' : '#ccc'">
                {{ this.CurrentInvoice.Details.ShippingDetails?.ShippingCompany?.ID === s.ID ? 'check_circle' : 'radio_button_unchecked' }}
              </i>
              <span class="CustomDropdownResultText">{{s.Name}}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Weight Type Dropdown -->
      <div class="CustomDropdownContainer">
        <div class="SendEmailOverlayTransparent" *ngIf="showWeightTypeDropdown" (click)="showWeightTypeDropdown = false"></div>
        <div class="CustomDropdownBar" (click)="showWeightTypeDropdown = !showWeightTypeDropdown">
          <span class="dropdown-label">{{ 'WeightType' | translate }}</span>
          <i class="material-icons dropdown-icon-left">scale</i>
          <i class="material-icons send-email-icon" [style.color]="this.CurrentInvoice.Details.ShippingDetails?.WeightType?.ID ? '#4caf50' : '#f44336'">
            {{ this.CurrentInvoice.Details.ShippingDetails?.WeightType?.ID ? 'check_circle' : 'cancel' }}
          </i>
          <input type="text" class="CustomDropdownInput" [class.placeholder]="!this.CurrentInvoice.Details.ShippingDetails?.WeightType" [value]="this.CurrentInvoice.Details.ShippingDetails?.WeightType?.Name || ''" readonly />
          <i class="material-icons dropdown-icon">arrow_drop_down</i>
        </div>
        <div class="CustomDropdownResults" *ngIf="showWeightTypeDropdown">
          <div class="CustomDropdownResult" *ngFor="let t of this.WeightTypes" (click)="this.CurrentInvoice.Details.ShippingDetails.WeightType = t; showWeightTypeDropdown = false;">
            <div class="CustomDropdownResultMain">
              <i class="material-icons" [style.color]="this.CurrentInvoice.Details.ShippingDetails?.WeightType?.ID === t.ID ? '#4caf50' : '#ccc'">
                {{ this.CurrentInvoice.Details.ShippingDetails?.WeightType?.ID === t.ID ? 'check_circle' : 'radio_button_unchecked' }}
              </i>
              <span class="CustomDropdownResultText">{{t.Name}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Transported Boxes Section Header -->
    <div class="ModernFormSectionHeader AppleSectionHeader" (click)="shippingBoxesCollapsed = !shippingBoxesCollapsed" style="margin-top: 16px;">
      <div class="AppleSectionHeaderLeft">
        <i class="material-icons AppleSectionIcon">inventory_2</i>
        <span class="AppleSectionTitle">{{'TransportedBoxesInformation' | translate}}</span>
        <span class="parcel-count-badge" *ngIf="this.CurrentInvoice?.Details?.ShippingDetails?.Boxes?.length > 0">
          {{this.CurrentInvoice.Details.ShippingDetails.Boxes.length}}
        </span>
      </div>
      <i class="material-icons AppleSectionChevron" [class.collapsed]="shippingBoxesCollapsed">expand_more</i>
    </div>

    <div class="AppleSectionContent" *ngIf="!shippingBoxesCollapsed">
      <button class="ModernButton ModernButtonPrimary" (click)="AddNewBox();" style="margin-bottom: 10px;">
        <i class="material-icons" style="font-size: 16px; margin-right: 4px;">add</i>
        {{'AddNewParcel' | translate}}
      </button>

      <!-- Parcels Table Header -->
      <div class="parcels-table-header" *ngIf="this.CurrentInvoice?.Details?.ShippingDetails?.Boxes?.length > 0;">
        <div class="parcel-col parcel-col-index">#</div>
        <div class="parcel-col parcel-col-dim">{{ 'Length' | translate }}</div>
        <div class="parcel-col-separator">×</div>
        <div class="parcel-col parcel-col-dim">{{ 'Width' | translate }}</div>
        <div class="parcel-col-separator">×</div>
        <div class="parcel-col parcel-col-dim">{{ 'Height' | translate }}</div>
        <div class="parcel-col-separator">—</div>
        <div class="parcel-col parcel-col-weight">{{ 'Weight' | translate }}</div>
        <div class="parcel-col-separator">—</div>
        <div class="parcel-col parcel-col-pallet">{{ 'Pallet' | translate }}?</div>
        <div class="parcel-col-separator">—</div>
        <div class="parcel-col parcel-col-tracking">{{ 'TrackingLabel' | translate }}</div>
        <div class="parcel-col parcel-col-actions"></div>
      </div>

      <!-- Parcel Rows -->
      <div class="parcel-row" *ngFor="let box of this.CurrentInvoice.Details.ShippingDetails.Boxes; let j=index;">
        <div class="parcel-col parcel-col-index">
          <span class="parcel-type-label">{{box.IsPallet ? ('Pallet' | translate) : ('Parcel' | translate)}}</span>
          <span class="parcel-number">#{{j + 1}}</span>
        </div>

        <div class="parcel-col parcel-col-dim">
          <input type="number" class="parcel-input" placeholder="{{'Length' | translate}}" autocomplete="off" [(ngModel)]="box.Length" (click)="$event.target.select()">
        </div>

        <div class="parcel-col-separator">×</div>

        <div class="parcel-col parcel-col-dim">
          <input type="number" class="parcel-input" placeholder="{{'Width' | translate}}" autocomplete="off" [(ngModel)]="box.Width" (click)="$event.target.select()">
        </div>

        <div class="parcel-col-separator">×</div>

        <div class="parcel-col parcel-col-dim">
          <input type="number" class="parcel-input" placeholder="{{'Height' | translate}}" autocomplete="off" [(ngModel)]="box.Height" (click)="$event.target.select()">
        </div>

        <div class="parcel-col-separator">—</div>

        <div class="parcel-col parcel-col-weight">
          <input type="number" class="parcel-input" [placeholder]="this.CurrentInvoice?.Details?.ShippingDetails?.WeightType?.Name || ('Weight' | translate)" autocomplete="off" [(ngModel)]="box.Weight" (click)="$event.target.select()">
        </div>

        <div class="parcel-col-separator">—</div>

        <div class="parcel-col parcel-col-pallet">
          <label class="MinimalistToggle">
            <input type="checkbox" [(ngModel)]="box.IsPallet">
            <span class="MinimalistToggle__slider"></span>
          </label>
        </div>

        <div class="parcel-col-separator">—</div>

        <div class="parcel-col parcel-col-tracking">
          <input type="text" class="parcel-input" placeholder="{{'TrackingLabel' | translate}}" autocomplete="off" [(ngModel)]="box.TrackingLabel">
        </div>

        <div class="parcel-col parcel-col-actions">
          <i class="material-icons parcel-status-icon" *ngIf="box.ID > 0;">check_circle</i>
          <i class="material-icons parcel-delete-icon" (click)="CurrentBox = box; ShowDeleteBoxQuestion = true;" role="button">close</i>
        </div>
      </div>
    </div>

  </div>
  <div class="ShippingDetailsContainerCommands">
    <button *ngIf="this.CurrentInvoice.Details.ShippingDetails?.ID > 0;" class="ModernButton ModernButtonDanger" style="float:left;" (click)="ShowDeleteShippingDetailsContainer = true;">
      <i class="material-icons">delete_forever</i>
    </button>
    <button class="ModernButton ModernButtonPrimary" style="float:right;" (click)="ShowShippingDetailsContainer = false;">OK</button>
    <button class="ModernButton ModernButtonAccent" style="float:right;margin-right: 10px;" (click)="ProofShippingDetails(this.CurrentInvoice.Details.ShippingDetails, true);">{{'SaveToDB' | translate}}</button>
    <button *ngIf="this.CurrentInvoice.Details?.ShippingDetails?.TrackingLabel?.length > 0 && this.CurrentInvoice.Details?.ShippingDetails?.ETDUploadStatus?.ID !== 1 && this.CurrentInvoice.Details?.ShippingDetails?.ETDUploadStatus?.ID !== -2;"
            class="ModernButton ModernButtonSecondary" style="float:right;margin-right: 10px;min-width:36px;"
            [disabled]="UploadInvoiceToCarrierLoading"
            (click)="UploadInvoiceToCarrier();"
            [matTooltip]="'UploadInvoiceToCarrier' | translate">
      <i class="material-icons" *ngIf="!UploadInvoiceToCarrierLoading">cloud_upload</i>
      <mat-spinner *ngIf="UploadInvoiceToCarrierLoading" [diameter]="18"></mat-spinner>
    </button>
    <button *ngIf="this.CurrentInvoice.Details?.ShippingDetails?.ETDUploadStatus?.ID === -2;"
            class="ModernButton" style="float:right;margin-right: 10px;min-width:36px;background:#fd4f57;color:#fff;"
            [disabled]="UploadInvoiceToCarrierLoading"
            (click)="UploadInvoiceToCarrier();"
            [matTooltip]="'ETDUploadError' | translate">
      <i class="material-icons" *ngIf="!UploadInvoiceToCarrierLoading">cloud_off</i>
      <mat-spinner *ngIf="UploadInvoiceToCarrierLoading" [diameter]="18"></mat-spinner>
    </button>
    <button *ngIf="this.CurrentInvoice.Details?.ShippingDetails?.ETDUploadStatus?.ID === 1;"
            class="ModernButton" style="float:right;margin-right: 10px;min-width:36px;background:#32aa3a;color:#fff;opacity:0.85;cursor:default;"
            [disabled]="true"
            [matTooltip]="('UploadInvoiceToCarrier' | translate) + ' ✓ — TraceID: ' + (this.CurrentInvoice.Details?.ShippingDetails?.ETDUploadTraceID || 'N/A')">
      <i class="material-icons">cloud_done</i>
    </button>
  </div>
</div>

<!-- Reception Edit Product Overlay - Outside MainContainer for proper viewport coverage -->
<div class="reception-edit-overlay" *ngIf="ShowReceptionEditProductContainer"
     (click)="ShowReceptionEditProductContainer = false; RevertProduct();"></div>

<!-- Reception Edit Product Popup - Outside MainContainer for proper fixed positioning -->
<div class="ReceptionEditProductContainer" *ngIf="ShowReceptionEditProductContainer">
  <div class="PopUpCloseContainer" (click)="ShowReceptionEditProductContainer = false;RevertProduct();">
    <i class="material-icons">close</i>
  </div>
  <div class="ReceptionEditProductTitleContainer">
    <p>
      <i class="material-icons titleModificationIcon">build</i>
      {{CurrentProduct.ProductInvoiceInfo.Name}}
    </p>
  </div>

  <div class="PopUpBody" *ngIf="!loadingEditProduct">
    <div class="PopUpBodyRowContainer" *ngIf="CurrentProduct.ID == null;">
      <div class="PopUpBodyTwoThirdsContainer">
        <p class="NewTextBoxContainerTitle">{{ 'Receptions.Administration' | translate }}</p>
        <div class="NewTextBoxContainer" style="width: 100%;">
          <mat-select class="NewTextBox" name="Administration" [compareWith]="compareFirst" [(ngModel)]="CurrentProduct.ProductInvoiceInfo.Administration">
            <mat-option *ngFor="let a of this.Administrations;" [value]="a">
              {{a.Name}}
            </mat-option>
          </mat-select>
        </div>
      </div>

      <div class="PopUpBodyOneThirddContainer">
        <p class="NewTextBoxContainerTitle">{{ 'HOME.ProductType' | translate }}</p>
        <div class="NewTextBoxContainer" style="width: 100%;">
          <mat-select class="NewTextBox" name="vats" [compareWith]="compareFirst" [(ngModel)]="CurrentProduct.ProductInvoiceInfo.GeneralType">
            <mat-option *ngFor="let t of this.ProductGeneralTypes" [value]="t" (onSelectionChange)="chanveNewProductVALUE($event);">
              {{t.Name}}
            </mat-option>
          </mat-select>
        </div>
      </div>
    </div>

    <div class="PopUpBodyRowContainer" *ngIf="CurrentProduct.ID != null;">
      <div class="PopUpBodyTwoThirdsContainer">
        <p class="NewTextBoxContainerTitle">{{ 'Receptions.Administration' | translate }}</p>
        <div class="NewTextBoxContainer" style="width: 100%;">
          <input class="NewTextBox" type="text" disabled="disabled" placeholder="{{ 'Receptions.Administration' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductInvoiceInfo.Administration.Name">
        </div>
      </div>

      <div class="PopUpBodyOneThirddContainer">
        <p class="NewTextBoxContainerTitle">{{ 'HOME.ProductType' | translate }}</p>
        <div class="NewTextBoxContainer" style="width: 100%;">
          <input class="NewTextBox" type="text" disabled="disabled" placeholder="{{ 'HOME.ProductType' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductInvoiceInfo.GeneralType.Name">
        </div>
      </div>
    </div>

    <div class="PopUpBodyRowContainer">
      <div class="PopUpBodyTwoThirdsContainer">
        <p class="NewTextBoxContainerTitle">{{ 'Receptions.Table.Name' | translate }}</p>
        <div class="NewTextBoxContainer" style="width: 100%;position: relative;">
          <input class="NewTextBox" type="text" placeholder="{{ 'Receptions.Table.Name' | translate }}" (click)="SearchProductsInvoicingInformation(CurrentProduct.ProductInvoiceInfo.Name, CurrentProduct.ProductInvoiceInfo.Administration.ID, true);showhideSearches(true);" autocomplete="off" [(ngModel)]="CurrentProduct.ProductInvoiceInfo.Name" (ngModelChange)="chanveNewProductVALUE($event); SearchProductsInvoicingInformation(CurrentProduct.ProductInvoiceInfo.Name, CurrentProduct.ProductInvoiceInfo.Administration.ID, true);">
          <i class="material-icons NewTextBoxIcon" style="cursor: pointer;" *ngIf="ProductsSearchResultsCOUNTPop == 0 && !loadingSearchProducts && CurrentProduct.ProductInvoiceInfo.Name.length == 0;">search</i>
          <i class="material-icons NewTextBoxIcon" style="cursor: pointer;" *ngIf="(ProductsSearchResultsCOUNTPop > 0 || CurrentProduct.ProductInvoiceInfo.Name.length > 0) && !loadingSearchProducts;" (click)="DestroySearchedProducts();">close</i>
        </div>
        <div class="SpinnerIconContainerPopUp" *ngIf="loadingSearchProducts">
          <mat-spinner class="smallSpinner" [diameter]="25"></mat-spinner>
        </div>
      </div>
      <div class="PopUpBodyOneThirddContainer">
        <p class="NewTextBoxContainerTitle">{{ 'Receptions.Table.Code' | translate }}</p>
        <div class="NewTextBoxContainer" style="width: 100%;">
          <input class="NewTextBox" type="text" disabled *ngIf="CurrentProduct.ProductInvoiceInfo.ProductID != null;" placeholder="{{ 'Receptions.Table.Code' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductInvoiceInfo.Code">
          <input class="NewTextBox" type="text" *ngIf="CurrentProduct.ProductInvoiceInfo.ProductID == null;" placeholder="{{ 'Receptions.Table.Code' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductInvoiceInfo.Code">
        </div>
      </div>
      <div class="ProductsSearchResultsContainer ProductsSearchResultsContainerPopException" *ngIf="ProductsSearchResultsCOUNTPop > 0 && showSearchCurrent;">
        <div class="ProductSearchResult" *ngFor="let p of ProductsSearchResultsPop" (click)="SelectReceptionProductFromSearchCurrent(p);">
          <p class="ProductSearchResultTitle">{{p.Name}}</p>
        </div>
      </div>
    </div>

    <div class="PopUpBodyRowContainer">
      <div class="PopUpBodyTwoThirdsContainer">
        <mat-form-field appearance="outline" class="ReceptionProductsColSearch">
          <mat-label>{{ 'Description' | translate }}</mat-label>
          <textarea autocomplete="off" matInput
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="1"
                    cdkAutosizeMaxRows="10"
                    [(ngModel)]="CurrentProduct.ProductInvoiceInfo.Description"></textarea>
        </mat-form-field>
      </div>
    </div>

    <div class="PopUpBodyRowContainer">
      <div class="PopUpBodyOneThirddContainer">
        <p class="NewTextBoxContainerTitle">{{ 'Receptions.Table.MU' | translate }}</p>
        <div class="NewTextBoxContainer" style="width: 100%;">
          <mat-select class="NewTextBox" name="MeasuringUnit" [compareWith]="compareFirst" [(ngModel)]="CurrentProduct.ProductInvoiceInfo.MeasuringUnit">
            <mat-option *ngFor="let u of this.MeasuringUnits" [value]="u">
              {{u.Name}}
            </mat-option>
          </mat-select>
        </div>
      </div>
      <div class="PopUpBodyOneThirddContainer">
        <p class="NewTextBoxContainerTitle">{{ 'Receptions.Table.Qty' | translate }}</p>
        <div class="NewTextBoxContainer" style="width: 100%;">
          <input class="NewTextBox" type="text" placeholder="{{ 'Receptions.Table.Qty' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductInvoiceInfo.Quantity">
        </div>
      </div>
      <div class="PopUpBodyOneThirddContainer">
      </div>
    </div>

    <div class="PopUpBodyRowContainer">
      <div class="PopUpBodyOneThirddContainer">
        <p class="NewTextBoxContainerTitle">{{ 'Receptions.Table.PriceNOVAT' | translate }}</p>
        <div class="NewTextBoxContainer" style="width: 100%;">
          <input class="NewTextBox" type="text" [disabled]="CurrentProduct.ProductInvoiceInfo.PriceContainsVAT" placeholder="{{ 'Receptions.Table.Price' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductInvoiceInfo.Price.UIUnitPrice" (change)="VerifyPriceModel(CurrentProduct.ProductInvoiceInfo.Price.UIUnitPrice);">
        </div>
      </div>

      <div class="PopUpBodyOneThirddContainer">
        <p class="NewTextBoxContainerTitle">{{ 'Receptions.Table.PriceVAT' | translate }}</p>
        <div class="NewTextBoxContainer" style="width: 100%;">
          <input class="NewTextBox" type="text" [disabled]="!CurrentProduct.ProductInvoiceInfo.PriceContainsVAT" placeholder="{{ 'Receptions.Table.Price' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductInvoiceInfo.Price.UIVATUnitPrice" (change)="VerifyPriceModel(CurrentProduct.ProductInvoiceInfo.Price.UIVATUnitPrice);">
        </div>
      </div>

      <div class="PopUpBodyOneThirddContainer">
        <p class="NewTextBoxContainerTitle">{{ 'Receptions.Table.VAT' | translate }}</p>
        <div class="NewTextBoxContainer" style="width: 100%;">
          <mat-select class="NewTextBox" name="vats" [compareWith]="compareFirst" [(ngModel)]="CurrentProduct.ProductInvoiceInfo.Price.VAT">
            <mat-option *ngFor="let v of this.VATRates" [value]="v" (click)="ModifyReceptionProduct(true);">
              {{v.Name}}
            </mat-option>
          </mat-select>
        </div>
      </div>
    </div>

    <div class="PopUpBodyRowContainer">
      <div class="PopUpBodyOneThirddContainer">
        <mat-slide-toggle (change)="priceContainsVATchanged($event)" [(ngModel)]="CurrentProduct.ProductInvoiceInfo.PriceContainsVAT">{{ 'Receptions.Table.PriceContainsVAT' | translate }}</mat-slide-toggle>
      </div>
    </div>

    <div class="DiscountRow" *ngIf="CurrentProduct.ProductInvoiceInfo.Price.Discount != null && CurrentProduct.ProductInvoiceInfo.Price.Discount.Value != null && CurrentInvoice.Total.Discount.Value == null;">
      <p class="DiscountRowTitle">
        {{CurrentProduct.ProductInvoiceInfo.Price.Discount.Type.Name}} Discount - {{CurrentProduct.ProductInvoiceInfo.Price.Discount.Value}}
        <span *ngIf="CurrentProduct.ProductInvoiceInfo.Price.Discount.Type.ID == 1;">%</span>
        <span> ({{currency.Name}})</span>
      </p>

      <div class="PopUpBodyOneThirddContainer">
        <p class="NewTextBoxContainerTitle">{{ 'Receptions.Table.PriceNOVAT' | translate }}</p>
        <div class="NewTextBoxContainer" style="width: 100%;">
          <input class="NewTextBox" type="text" [disabled]="true" placeholder="{{ 'Receptions.Table.Price' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductInvoiceInfo.Price.UIUnitPriceDiscount">
        </div>
      </div>

      <div class="PopUpBodyOneThirddContainer">
        <p class="NewTextBoxContainerTitle">{{ 'Receptions.Table.PriceVAT' | translate }}</p>
        <div class="NewTextBoxContainer" style="width: 100%;">
          <input class="NewTextBox" type="text" [disabled]="true" placeholder="{{ 'Receptions.Table.Price' | translate }}" autocomplete="off" [(ngModel)]="CurrentProduct.ProductInvoiceInfo.Price.UIVATUnitPriceDiscount">
        </div>
      </div>

      <div class="PopUpBodyRowContainer">
        <button class="ModernButton ModernButtonDanger" (click)="EliminateProductDiscount();">
          <i class="material-icons buttonIcon">close</i>
          {{ 'Receptions.EliminateDiscount' | translate }}
        </button>
      </div>
    </div>

  </div>

  <div class="PopUpBody" *ngIf="loadingEditProduct">
    <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
  </div>

  <div class="PopUpCommands">
    <button class="ModernButton ModernButtonPrimary ReceptionEditProductSaveButton" (click)="ModifyReceptionProduct();">
      <i class="material-icons buttonIcon">check</i>
      {{'ModifyProduct' | translate}}
    </button>
  </div>
</div>

<!-- Partner Popup Overlay - Outside MainContainer for proper viewport coverage -->
<div class="partner-popup-overlay" *ngIf="showAddNewPartnerPopUp || showEditPartnerPopUp"
     (click)="showAddNewPartnerPopUp = false; showEditPartnerPopUp = false;"></div>

<!-- Add New Partner Popup - Outside MainContainer for proper fixed positioning -->
<div *ngIf="showAddNewPartnerPopUp" class="NewPartnerPopUp">
  <div class="partner-popup-header">
    <div class="partner-popup-title">
      <i class="material-icons">person_add</i>
      <span>{{ 'Partners.AddNewPartner' | translate }}</span>
    </div>
    <button class="partner-popup-close" (click)="showAddNewPartnerPopUp = false;">
      <i class="material-icons">close</i>
    </button>
  </div>

  <div class="partner-popup-body">

    <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.General' | translate }}</p>

    <form [formGroup]="newPartner" class="partner-form-grid">
      <div class="MinimalistInputContainer">
        <label class="MinimalistInputLabel">{{ 'Partners.VAT' | translate }}</label>
        <div class="MinimalistInputWithAction">
          <input class="MinimalistInput" placeholder="ex. RO1234567" autocomplete="off" formControlName="VAT">
          <button type="button" class="MinimalistInputWithAction__button"
                  (click)="GetPartnerEUData(this.newPartner, true);"
                  *ngIf="this.newPartner.controls['VAT'].value != null && this.newPartner.controls['VAT'].value.length && this.newPartner.controls['Country'].value != null;">
            <i class="material-icons">cloud_download</i>
          </button>
        </div>
      </div>

      <div class="MinimalistInputContainer">
        <label class="MinimalistInputLabel">{{ 'Partners.UPN' | translate }}</label>
        <input class="MinimalistInput" placeholder="ex. CNP - RO" autocomplete="off" formControlName="UPN">
      </div>

      <div class="MinimalistInputContainer">
        <label class="MinimalistInputLabel">{{ 'Partners.Name' | translate }} *</label>
        <input class="MinimalistInput" placeholder="" autocomplete="off" formControlName="Name" required>
      </div>

      <div class="MinimalistInputContainer">
        <label class="MinimalistInputLabel">{{ 'Partners.PartnerWindow.COCRegNumber' | translate }}</label>
        <input class="MinimalistInput" placeholder="" autocomplete="off" formControlName="COCRegNumber">
      </div>

      <div class="MinimalistToggleContainer">
        <label class="MinimalistToggle">
          <input type="checkbox" formControlName="TaxPayer">
          <span class="MinimalistToggle__slider"></span>
        </label>
        <span class="MinimalistToggle__label">{{ 'Partners.PartnerWindow.TaxPayer' | translate }}</span>
      </div>

      <p class="PopUpBodySubTitle" style="flex: 1 1 100%; margin-top: 10px;">{{ 'Partners.PartnerWindow.Address' | translate }}</p>

      <div class="MinimalistInputContainer">
        <label class="MinimalistInputLabel">{{ 'Partners.PartnerWindow.ChooseCountry' | translate }} *</label>
        <select class="MinimalistSelect" [(ngModel)]="newPartnerCountry" formControlName="Country" [compareWith]="compareFn" required>
          <option [ngValue]="null" disabled>{{ 'Partners.PartnerWindow.ChooseCountry' | translate }}</option>
          <option *ngFor="let c of parent.masterData.Countries" [ngValue]="c">{{c.Name}}</option>
        </select>
      </div>

      <div class="MinimalistInputContainer">
        <label class="MinimalistInputLabel">{{ 'Partners.PartnerWindow.StateProvince' | translate }}</label>
        <input class="MinimalistInput" placeholder="" autocomplete="off" formControlName="StateProvince">
      </div>

      <div class="MinimalistInputContainer">
        <label class="MinimalistInputLabel">{{ 'Partners.PartnerWindow.City' | translate }}</label>
        <input class="MinimalistInput" placeholder="" autocomplete="off" formControlName="City">
      </div>

      <div class="MinimalistInputContainer">
        <label class="MinimalistInputLabel">{{ 'Partners.PartnerWindow.AddressLine' | translate }} *</label>
        <input class="MinimalistInput" placeholder="" autocomplete="off" formControlName="AddressLine" required>
      </div>

      <div class="MinimalistInputContainer">
        <label class="MinimalistInputLabel">{{ 'ZipCode' | translate }}</label>
        <input class="MinimalistInput" placeholder="" autocomplete="off" formControlName="ZipCode">
      </div>

      <p class="PopUpBodySubTitle" style="flex: 1 1 100%; margin-top: 10px;">{{ 'Partners.PartnerWindow.Bank' | translate }}:</p>

      <div class="MinimalistInputContainer">
        <label class="MinimalistInputLabel">{{ 'Partners.PartnerWindow.ChooseBank' | translate }}</label>
        <select class="MinimalistSelect" [(ngModel)]="newPartnerBank" formControlName="Bank" [compareWith]="compareFn">
          <option [ngValue]="null">{{ 'Partners.PartnerWindow.ChooseBank' | translate }}</option>
          <option *ngFor="let b of parent.masterData.Banks" [ngValue]="b">{{b.Name}}</option>
        </select>
      </div>

      <div class="MinimalistInputContainer" *ngIf="newPartnerBank != null;">
        <label class="MinimalistInputLabel">{{ 'Partners.PartnerWindow.BankAccountNumber' | translate }}</label>
        <input class="MinimalistInput" placeholder="" autocomplete="off" formControlName="BankAccount">
      </div>

      <p class="PopUpBodySubTitle" style="flex: 1 1 100%; margin-top: 10px;">{{ 'Partners.PartnerWindow.ContactInfo' | translate }}</p>

      <div class="MinimalistInputContainer">
        <label class="MinimalistInputLabel">{{ 'Login.Email' | translate }}</label>
        <input class="MinimalistInput" placeholder="" autocomplete="off" formControlName="Email">
      </div>

      <div class="MinimalistInputContainer">
        <label class="MinimalistInputLabel">{{ 'Partners.PartnerWindow.Name' | translate }}</label>
        <input class="MinimalistInput" placeholder="" autocomplete="off" formControlName="ContactName">
      </div>

      <div class="MinimalistInputContainer">
        <label class="MinimalistInputLabel">{{ 'Login.Phone' | translate }}</label>
        <input class="MinimalistInput" placeholder="" autocomplete="off" formControlName="Phone">
      </div>
    </form>

  </div>

  <div class="partner-popup-footer">
    <button [disabled]="parent.loading" class="ModernButton ModernButtonPrimary" (click)="AddNewPartner();">
      <i class="material-icons buttonIcon">check</i>
      {{'Partners.AddNewPartner' | translate}}
    </button>
  </div>
</div>

<!-- Edit Partner Popup - Outside MainContainer for proper fixed positioning -->
<div *ngIf="showEditPartnerPopUp" class="NewPartnerPopUp">
  <div class="partner-popup-header">
    <div class="partner-popup-title">
      <i class="material-icons">edit</i>
      <span>{{ 'Partners.EditPartner' | translate }}</span>
    </div>
    <button class="partner-popup-close" (click)="showEditPartnerPopUp = false;">
      <i class="material-icons">close</i>
    </button>
  </div>

  <div class="partner-popup-body">

    <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.General' | translate }}</p>

    <form [formGroup]="currentPartner" class="partner-form-grid">
      <div class="MinimalistInputContainer">
        <label class="MinimalistInputLabel">{{ 'Partners.VAT' | translate }}</label>
        <div class="MinimalistInputWithAction">
          <input class="MinimalistInput" placeholder="ex. RO1234567" autocomplete="off" formControlName="VAT">
          <button type="button" class="MinimalistInputWithAction__button"
                  (click)="GetPartnerEUData(this.currentPartner, false);"
                  *ngIf="this.currentPartner.controls['VAT'].value != null && this.currentPartner.controls['VAT'].value.length;">
            <i class="material-icons">cloud_download</i>
          </button>
        </div>
      </div>

      <div class="MinimalistInputContainer">
        <label class="MinimalistInputLabel">{{ 'Partners.UPN' | translate }}</label>
        <input class="MinimalistInput" placeholder="ex. CNP - RO" autocomplete="off" formControlName="UPN">
      </div>

      <div class="MinimalistInputContainer">
        <label class="MinimalistInputLabel">{{ 'Partners.PartnerWindow.Name' | translate }} *</label>
        <input class="MinimalistInput" placeholder="" autocomplete="off" formControlName="Name" required>
      </div>

      <div class="MinimalistInputContainer">
        <label class="MinimalistInputLabel">{{ 'Partners.PartnerWindow.COCRegNumber' | translate }}</label>
        <input class="MinimalistInput" placeholder="" autocomplete="off" formControlName="COCRegNumber">
      </div>

      <div class="MinimalistToggleContainer">
        <label class="MinimalistToggle">
          <input type="checkbox" formControlName="TaxPayer">
          <span class="MinimalistToggle__slider"></span>
        </label>
        <span class="MinimalistToggle__label">{{ 'Partners.PartnerWindow.TaxPayer' | translate }}</span>
      </div>

      <p class="PopUpBodySubTitle" style="flex: 1 1 100%; margin-top: 10px;">{{ 'Partners.PartnerWindow.Address' | translate }}</p>

      <div class="MinimalistInputContainer">
        <label class="MinimalistInputLabel">{{ 'Partners.PartnerWindow.ChooseCountry' | translate }} *</label>
        <select class="MinimalistSelect" formControlName="Country" [compareWith]="compareFn" required>
          <option [ngValue]="null" disabled>{{ 'Partners.PartnerWindow.ChooseCountry' | translate }}</option>
          <option *ngFor="let c of parent.masterData.Countries" [ngValue]="c">{{c.Name}}</option>
        </select>
      </div>

      <div class="MinimalistInputContainer">
        <label class="MinimalistInputLabel">{{ 'Partners.PartnerWindow.StateProvince' | translate }} *</label>
        <input class="MinimalistInput" placeholder="" autocomplete="off" formControlName="StateProvince" required>
      </div>

      <div class="MinimalistInputContainer">
        <label class="MinimalistInputLabel">{{ 'Partners.PartnerWindow.City' | translate }} *</label>
        <input class="MinimalistInput" placeholder="" autocomplete="off" formControlName="City" required>
      </div>

      <div class="MinimalistInputContainer">
        <label class="MinimalistInputLabel">{{ 'Partners.PartnerWindow.AddressLine' | translate }} *</label>
        <input class="MinimalistInput" placeholder="" autocomplete="off" formControlName="AddressLine" required>
      </div>

      <div class="MinimalistInputContainer">
        <label class="MinimalistInputLabel">{{ 'ZipCode' | translate }}</label>
        <input class="MinimalistInput" placeholder="" autocomplete="off" formControlName="ZipCode">
      </div>

      <p class="PopUpBodySubTitle" style="flex: 1 1 100%; margin-top: 10px;">{{ 'Partners.PartnerWindow.Bank' | translate }}</p>

      <div class="MinimalistInputContainer">
        <label class="MinimalistInputLabel">{{ 'Partners.PartnerWindow.ChooseBank' | translate }}</label>
        <select class="MinimalistSelect" formControlName="Bank" [compareWith]="compareFn">
          <option [ngValue]="null">{{ 'Partners.PartnerWindow.ChooseBank' | translate }}</option>
          <option *ngFor="let b of parent.masterData.Banks" [ngValue]="b">{{b.Name}}</option>
        </select>
      </div>

      <div class="MinimalistInputContainer">
        <label class="MinimalistInputLabel">{{ 'Partners.PartnerWindow.BankAccountNumber' | translate }}</label>
        <input class="MinimalistInput" placeholder="" autocomplete="off" formControlName="BankAccount">
      </div>

      <p class="PopUpBodySubTitle" style="flex: 1 1 100%; margin-top: 10px;">{{ 'Partners.PartnerWindow.ContactInfo' | translate }}</p>

      <div class="MinimalistInputContainer">
        <label class="MinimalistInputLabel">{{ 'Login.Email' | translate }}</label>
        <input class="MinimalistInput" placeholder="" autocomplete="off" formControlName="Email">
      </div>

      <div class="MinimalistInputContainer">
        <label class="MinimalistInputLabel">{{ 'Partners.PartnerWindow.Name' | translate }}</label>
        <input class="MinimalistInput" placeholder="" autocomplete="off" formControlName="ContactName">
      </div>

      <div class="MinimalistInputContainer">
        <label class="MinimalistInputLabel">{{ 'Login.Phone' | translate }}</label>
        <input class="MinimalistInput" placeholder="" autocomplete="off" formControlName="Phone">
      </div>
    </form>

  </div>

  <div class="partner-popup-footer">
    <button [disabled]="parent.loading" class="ModernButton ModernButtonPrimary" (click)="UpdatePartner();">
      <i class="material-icons buttonIcon">check</i>
      {{'UpdatePartner' | translate}}
    </button>
  </div>
</div>

<!-- Insurance Policy Settings Container -->
<div class="ModernPopupOverlay" *ngIf="ShowInsurancePolicyContainer">
  <div class="ModernPopup animated fadeInDown" style="max-width: 500px; width: 90%;">
    <div class="ModernPopupHeader">
      <div class="ModernPopupTitle">
        <i class="material-icons">policy</i>
        {{ 'InsurancePolicySettings' | translate }}
      </div>
      <button class="ModernPopupClose" (click)="ShowInsurancePolicyContainer = false;">
        <i class="material-icons">close</i>
      </button>
    </div>

    <div class="ModernPopupBody" style="padding: 24px;">

      <!-- Insurance Value -->
      <div class="ModernFormGroup">
        <label class="ModernFormLabel">{{'InsuranceValue' | translate}} (%)</label>
        <input class="ModernFormInput" type="number" step="0.1" min="0" max="100"
               [(ngModel)]="InsurancePolicySettings.InsuranceValue">
        <span class="ModernFormHint" style="font-style: italic;">{{'InsuranceValueDesc' | translate}}</span>
      </div>

      <!-- Dictator Dropdown -->
      <div class="ModernFormGroup">
        <label class="ModernFormLabel">{{'InsuranceDictator' | translate}}</label>
        <div class="ModernDropdownContainer">
          <div class="ModernDropdownOverlay" *ngIf="showInsuranceDictatorDropdown" (click)="showInsuranceDictatorDropdown = false"></div>
          <div class="ModernDropdownBar" [class.open]="showInsuranceDictatorDropdown" (click)="showInsuranceDictatorDropdown = !showInsuranceDictatorDropdown">
            <span class="ModernDropdownText" [class.placeholder]="!InsurancePolicySettings?.Dictator">
              {{InsurancePolicySettings?.Dictator?.Name ? (InsurancePolicySettings.Dictator.Name | translate) : ('SelectDictator' | translate)}}
            </span>
            <i class="material-icons ModernDropdownArrow">expand_less</i>
          </div>
          <div class="ModernDropdownResults upward" *ngIf="showInsuranceDictatorDropdown">
            <div class="ModernDropdownOption" *ngFor="let d of InsurancePolicyDictators"
                 [class.selected]="InsurancePolicySettings?.Dictator?.ID === d.ID"
                 (click)="InsurancePolicySettings.Dictator = d; showInsuranceDictatorDropdown = false;">
              {{d.Name | translate}}
              <i class="material-icons check-icon" *ngIf="InsurancePolicySettings?.Dictator?.ID === d.ID">check</i>
            </div>
          </div>
        </div>
        <span class="ModernFormHint" style="font-style: italic;">{{'InsuranceDictatorDesc' | translate}}</span>
      </div>

      <!-- Illustrator Dropdown -->
      <div class="ModernFormGroup">
        <label class="ModernFormLabel">{{'InsuranceIllustrator' | translate}}</label>
        <div class="ModernDropdownContainer">
          <div class="ModernDropdownOverlay" *ngIf="showInsuranceIllustratorDropdown" (click)="showInsuranceIllustratorDropdown = false"></div>
          <div class="ModernDropdownBar" [class.open]="showInsuranceIllustratorDropdown" (click)="showInsuranceIllustratorDropdown = !showInsuranceIllustratorDropdown">
            <span class="ModernDropdownText" [class.placeholder]="!InsurancePolicySettings?.Illustrator">
              {{InsurancePolicySettings?.Illustrator?.Name ? (InsurancePolicySettings.Illustrator.Name | translate) : ('SelectIllustrator' | translate)}}
            </span>
            <i class="material-icons ModernDropdownArrow">expand_less</i>
          </div>
          <div class="ModernDropdownResults upward" *ngIf="showInsuranceIllustratorDropdown">
            <div class="ModernDropdownOption" *ngFor="let i of InsurancePolicyIllustrators"
                 [class.selected]="InsurancePolicySettings?.Illustrator?.ID === i.ID"
                 (click)="InsurancePolicySettings.Illustrator = i; showInsuranceIllustratorDropdown = false;">
              {{i.Name | translate}}
              <i class="material-icons check-icon" *ngIf="InsurancePolicySettings?.Illustrator?.ID === i.ID">check</i>
            </div>
          </div>
        </div>
        <span class="ModernFormHint" style="font-style: italic;">{{'InsuranceIllustratorDesc' | translate}}</span>
      </div>

    </div>

    <div class="ModernPopupFooter" style="padding: 16px 24px; border-top: 1px solid #e8e8ed; display: flex; justify-content: flex-end; gap: 12px;">
      <button class="ModernButton outline" (click)="ShowInsurancePolicyContainer = false;">
        {{ 'Cancel' | translate }}
      </button>
      <button class="ModernButton success" [disabled]="this.parent.loading || this.DocumentBodyLoading" (click)="applyInsuranceWithCustomPolicy();">
        <i class="material-icons">add_circle_outline</i>
        {{ 'ApplyInsurance' | translate }}
      </button>
    </div>
  </div>
</div>

